window.escHtml = window.escHtml || function(s){ return (s||"").replace(/&/g,"&amp;").replace(/</g,"&lt;").replace(/>/g,"&gt;").replace(/"/g,"&quot;"); };

'use strict';

// ── Constants ─────────────────────────────────────────────────────────────────
var API = 'https://erp-ai-backend.vercel.app';

// ── State ─────────────────────────────────────────────────────────────────────
var TOKEN = null;
var USER  = null;
var _projects = [];
var _currentProject = null;
var _ticketSettings = { allow_pay_later: true, ticket_lead_days: 7, max_modules: 3, modules_list: [], ticket_note: '' };
var _wizTicket = null;
var _chatState = null;
var _chatTimer = null;
var _notifData = [];
var _notifOpen = false;
var _notifPoll = null;
var _tkCountdowns = {};
var _redirecting = false;

// ── Boot: read auth ───────────────────────────────────────────────────────────
(function() {
  try {
    TOKEN = localStorage.getItem('ls_proj_token');
    USER  = JSON.parse(localStorage.getItem('ls_proj_user') || 'null');
  } catch(e) {
    localStorage.removeItem('ls_proj_token');
    localStorage.removeItem('ls_proj_user');
    window.location.href = '/pages/erp-login?role=client';
    return;
  }
  if (!TOKEN || !USER || USER.role !== 'client') {
    location.href = '/pages/erp-login';
  }
})();

// ── API helper ────────────────────────────────────────────────────────────────
function api(method, path, body) {
  if (_redirecting) return Promise.resolve(new Response('{}', { status: 200 }));
  var opts = { method: method, headers: { 'Authorization': 'Bearer ' + TOKEN } };
  if (body) { opts.headers['Content-Type'] = 'application/json'; opts.body = JSON.stringify(body); }
  return fetch(API + path, opts).then(function(r) {
    if (r.status === 401 && !_redirecting) {
      _redirecting = true;
      clearInterval(_notifPoll);
      if (_chatTimer) clearInterval(_chatTimer);
      localStorage.removeItem('ls_proj_token');
      localStorage.removeItem('ls_proj_user');
      setTimeout(function() { location.href = '/pages/erp-login?session=expired'; }, 50);
    }
    return r;
  }).catch(function(e) {
    return new Response(JSON.stringify({ ok: false, error: e.message }), { status: 503, headers: { 'Content-Type': 'application/json' } });
  });
}

// ── Helpers ───────────────────────────────────────────────────────────────────
function fmtDate(d) { if (!d) return '—'; try { var dt = /^\d{4}-\d{2}-\d{2}$/.test(d) ? new Date(d + 'T00:00:00') : new Date(d); return dt.toLocaleDateString('en-GB', { day: 'numeric', month: 'short', year: 'numeric' }); } catch(e) { return d; } }

function badge(val, cls) {
  return '<span class="badge ' + (cls || 'b-' + (val || '').replace(/\s+/g, '_')) + '">' + ((val || '').replace(/_/g, ' ')) + '</span>';
}

function escHtml(s) { return esc(s); }
function esc(s) { return (s || '').replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/\n/g, '<br>'); }
function escAttr(s) { return (s || '').replace(/'/g, "\\'").replace(/"/g, '&quot;').replace(/\n/g, ' ').substring(0, 100); }

function toast(msg, type) {
  var t = document.getElementById('toast');
  if (!t) return;
  t.textContent = msg;
  t.className = 'show ' + (type || 'ok');
  clearTimeout(t._t);
  t._t = setTimeout(function() { t.className = ''; }, 3200);
}

function timeAgo(ds) {
  var d = Date.now() - new Date(ds).getTime();
  var s = Math.floor(d / 1000);
  if (s < 60) return 'just now';
  if (s < 3600) return Math.floor(s / 60) + 'm ago';
  if (s < 86400) return Math.floor(s / 3600) + 'h ago';
  return Math.floor(s / 86400) + 'd ago';
}

// ── Navigation ────────────────────────────────────────────────────────────────
function goSection(id, el) {
  destroyChat();
  // Hide ALL sections explicitly (both by class and by ID to prevent async race)
  var allSections = ['overview','projects','tickets','meetings','reports','inbox','profile','new-project'];
  allSections.forEach(function(s) {
    var sec = document.getElementById('sec-' + s);
    if (sec) { sec.style.display = 'none'; sec.classList.remove('active'); }
  });
  // Also hide project sub-views
  var pd = document.getElementById('proj-detail'); if (pd) pd.style.display = 'none';
  var pl = document.getElementById('proj-list');   if (pl) pl.style.display = 'none';
  document.querySelectorAll('#sidebar .nav-item').forEach(function(n) { n.classList.remove('active'); });

  var sec = document.getElementById('sec-' + id);
  if (sec) { sec.style.display = 'block'; sec.classList.add('active'); }
  if (el) { el.classList.add('active'); }
  else {
    document.querySelectorAll('#sidebar .nav-item').forEach(function(n) {
      if ((n.getAttribute('onclick') || '').includes("'" + id + "'")) n.classList.add('active');
    });
  }
  if (id === 'projects') { if (pl) { pl.style.display = 'block'; loadProjects(); } }
  if (id === 'tickets')   loadTickets();
  if (id === 'reports')   loadReports();
  if (id === 'meetings')  loadGlobalMeetings();
  if (id === 'new-project') { var d = document.getElementById('np-start'); if (d) d.min = new Date().toISOString().split('T')[0]; }
  if (id === 'profile')   refreshProfile();
  if (id === 'inbox')     loadClientInbox();
}

// ── Init ──────────────────────────────────────────────────────────────────────
(function init() {
  try {
    // Set nav name/avatar from localStorage immediately (no API call)
    if (USER) {
      var name = USER.full_name || USER.email || 'Client';
      var initials = name.trim().split(' ').map(function(w) { return w[0] || ''; }).join('').toUpperCase().slice(0, 2);
      var navName = document.getElementById('nav-name');
      var navAv   = document.getElementById('nav-av');
      if (navName) navName.textContent = name;
      if (navAv)   navAv.textContent   = initials;
      // Set avatar photo if available
      var av = USER.profile && USER.profile.avatar_url;
      if (av && navAv) {
        navAv.textContent = '';
        navAv.style.backgroundImage    = 'url(' + av + ')';
        navAv.style.backgroundSize     = 'cover';
        navAv.style.backgroundPosition = 'center';
      }
    }

    // Show overview section
    document.querySelectorAll('#main .section').forEach(function(s) { s.style.display = 'none'; s.classList.remove('active'); });
    var ov = document.getElementById('sec-overview');
    if (ov) { ov.style.display = 'block'; ov.classList.add('active'); }

    // Permission gates
    if (USER && USER.can_create_project === false) {
      var nb = document.getElementById('nav-new-project');
      var bb = document.getElementById('btn-new-proj');
      if (nb) nb.style.display = 'none';
      if (bb) bb.style.display = 'none';
    }

    // Set date minimums
    var npStart = document.getElementById('np-start');
    if (npStart) npStart.min = new Date().toISOString().split('T')[0];

    // Auto-detect timezone
    try {
      var tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
      var mfTz = document.getElementById('mf-tz');
      if (mfTz) mfTz.value = tz;
      var pTz = document.getElementById('p-tz');
      if (pTz) pTz.value = tz;
      var ntfTz = document.getElementById('ntf-tz');
      if (ntfTz) ntfTz.value = tz;
    } catch(e) {}

    // Fill profile from localStorage immediately
    fillProfile(USER);

    // Async loads
    loadOverview();
    loadProjects();
    startNotifPoll();
    checkPaymentReturn();
    checkInvoiceReturn();
    loadTicketSettings();

  } catch(e) {
    console.error('[Portal init]', e);
    var errEl = document.getElementById('portal-error');
    if (errEl) { errEl.style.display = 'block'; errEl.textContent = 'Portal error: ' + e.message + ' — please refresh.'; }
  }
})();

function logout() {
  api('POST', '/proj/auth/logout').catch(function() {});
  localStorage.removeItem('ls_proj_token');
  localStorage.removeItem('ls_proj_user');
  location.href = 'https://erponlinehub.com/pages/erp-login';
}

// ── Overview ──────────────────────────────────────────────────────────────────
async function loadOverview() {
  try {
    var r = await api('GET', '/proj/projects');
    var d = await r.json();
    _projects = d.projects || [];
  } catch(e) {
    _projects = [];
  }
  document.getElementById('ov-projects').textContent = _projects.length;
  document.getElementById('ov-active').textContent   = _projects.filter(function(p) { return p.status === 'active'; }).length;
  document.getElementById('ov-estimates').textContent = _projects.filter(function(p) { return p.status === 'estimated'; }).length;
  document.getElementById('ov-tasks').textContent = '—';
  // Handle deep-link section param (e.g. ?section=reports from invoice page)
  (function() {
    var params = new URLSearchParams(window.location.search);
    var sec = params.get('section');
    if (sec) {
      var navItem = document.querySelector('#sidebar .nav-item[onclick*="' + sec + '"]');
      if (navItem) { navItem.click(); }
      // Clean URL
      window.history.replaceState({}, '', window.location.pathname);
    }
  })();

  // Load rich counters + notification feed
  loadDashboardCounters();
  loadNotifFeed();

  var ov = document.getElementById('ov-name');
  if (ov) ov.textContent = (USER && USER.full_name) ? USER.full_name.split(' ')[0] : 'there';

  try {
    var tr = await api('GET', '/proj/tickets');
    var td = await tr.json();
    updateJourney(_projects, td.tickets || []);
  } catch(e) { updateJourney(_projects, []); }

  var recent = document.getElementById('ov-recent');
  if (recent) {
    recent.innerHTML = _projects.length
      ? '<div style="font-size:12px;font-weight:700;color:var(--muted);text-transform:uppercase;letter-spacing:.05em;margin-bottom:10px">Recent Projects</div>'
        + _projects.slice(0, 3).map(renderProjCard).join('')
      : '';
  }
  loadNavBadges();
}

function updateJourney(projects, tickets) {
  var hasProject  = projects.length > 0;
  var hasTicket   = tickets.length > 0;
  var hasPaid     = tickets.some(function(t) { return t.payment_status === 'paid'; });
  var hasActive   = projects.some(function(p) { return ['active', 'estimated'].includes(p.status); });
  var hasDocApproved = projects.some(function(p) { return p.doc_status === 'client_approved'; });
  var hasPendingDoc  = projects.some(function(p) { return p.doc_status === 'submitted'; });
  var hasApproved = projects.some(function(p) { return ['client_approved', 'paid', 'active', 'under_review', 'completed'].includes(p.status); });

  function setStep(n, state, fn) {
    var icon   = document.getElementById('ji-' + n);
    var status = document.getElementById('js-' + n);
    var action = document.getElementById('ja-' + n);
    if (!icon) return;
    if (state === 'done') {
      icon.className = 'j-icon done';
      if (status) { status.className = 'j-status js-done'; status.textContent = '✅ Done'; }
      if (action && fn) { action.className = 'j-action'; action.onclick = fn; }
    } else if (state === 'active') {
      icon.className = 'j-icon active';
      if (status) { status.className = 'j-status js-active'; status.textContent = '👉 Your turn'; }
      if (action && fn) { action.className = 'j-action'; action.onclick = fn; }
    } else {
      icon.className = 'j-icon';
      if (status) status.className = 'j-status js-pending';
      if (action) action.className = 'j-action disabled';
    }
  }

  setStep(1, hasProject ? 'done' : 'active', function() { goSection('new-project'); });
  setStep(2, hasTicket ? 'done' : (hasProject ? 'active' : 'pending'), function() { goSection('tickets'); startNewTicket(); });
  setStep(3, hasPaid ? 'done' : (hasTicket ? 'active' : 'pending'), function() { goSection('tickets'); });
  setStep(4, hasPaid ? (hasActive ? 'done' : 'active') : 'pending', null);
  setStep(5, hasDocApproved ? 'done' : ((hasPendingDoc || hasPaid) ? 'active' : 'pending'), function() { if (_projects.length) { openProject(_projects[0].id); setTimeout(function() { showProjectTab('documents'); }, 300); } });
  setStep(6, hasApproved ? 'done' : (hasDocApproved ? 'active' : 'pending'), function() { if (_projects.length) openProject(_projects[0].id); });
  setStep(7, hasApproved ? 'active' : 'pending', function() { goSection('projects'); });
  setStep(8, 'pending', function() { goSection('projects'); });
}

// ── Nav badges ────────────────────────────────────────────────────────────────
async function loadNavBadges() {
  try {
    var tasks = [], meets = [];
    for (var p of _projects) {
      var r = await api('GET', '/proj/projects/' + p.id);
      var d = await r.json();
      (d.tasks || []).forEach(function(t) { if (['submitted', 'client_testing'].includes(t.status)) tasks.push(t); });
      (d.meetings || []).forEach(function(m) { if (m.status === 'pending_confirmation' && m.confirmation_required_from === 'client') meets.push(m); });
    }
    var tb = document.getElementById('badge-tickets');
    if (tb && tasks.length) { tb.textContent = tasks.length; tb.style.display = 'inline'; }
    var mb = document.getElementById('badge-meetings');
    if (mb && meets.length) { mb.textContent = meets.length; mb.style.display = 'inline'; }
  } catch(e) {}
}

// ── Projects ──────────────────────────────────────────────────────────────────
async function loadProjects() {
  try {
    var r = await api('GET', '/proj/projects');
    var d = await r.json();
    _projects = d.projects || [];
  } catch(e) { _projects = []; }
  renderProjectList();
  loadNavBadges();
}

function renderProjectList() {
  var el = document.getElementById('proj-list');
  if (!el) return;
  var q = (document.getElementById('proj-search') || {}).value || '';
  var list = q ? _projects.filter(function(p) { return (p.title + p.erp_system + (p.project_number || '')).toLowerCase().includes(q.toLowerCase()); }) : _projects;
  el.innerHTML = list.length ? list.map(renderProjCard).join('') : '<div class="card"><div class="empty"><div class="empty-icon">📁</div><p>No projects yet. <button class="btn btn-primary btn-sm" onclick="goSection(\'new-project\')">Create Project →</button></p></div></div>';
}

function nextAction(p) {
  if (p.doc_status === 'submitted') return { label: '📄 Approve Plan →', cls: 'btn-warn', fn: "openProject('" + p.id + "');setTimeout(function(){showProjectTab('documents');},300)" };
  var map = {
    draft:          { label: '▶ Awaiting Start', cls: '', fn: '' },
    active:         { label: '📋 View Progress', cls: 'btn-primary', fn: "openProject('" + p.id + "')" },
    estimated:      { label: '📋 Review Estimate →', cls: 'btn-warn', fn: "openProject('" + p.id + "');showProjectTab('estimate')" },
    client_approved:{ label: '🔌 Add ERP Access', cls: 'btn-primary', fn: "openProject('" + p.id + "');showProjectTab('connections')" },
    under_review:   { label: '✅ Review Tasks', cls: 'btn-primary', fn: "openProject('" + p.id + "');showProjectTab('tasks')" },
    completed:      { label: '✅ Completed', cls: '', fn: '' },
    on_hold:        { label: '⏸ On Hold', cls: '', fn: '' },
  };
  return map[p.status] || { label: 'View Details', cls: 'btn-outline', fn: "openProject('" + p.id + "')" };
}

function renderProjCard(p) {
  var na = nextAction(p);
  return '<div class="proj-card" onclick="openProject(\'' + p.id + '\')">'
    + '<div style="display:flex;justify-content:space-between;align-items:flex-start">'
    + '<div><div class="proj-num">' + (p.project_number || '—') + '</div><div class="proj-title-text">' + esc(p.title) + '</div></div>'
    + badge(p.status) + '</div>'
    + '<div class="proj-meta">'
    + (p.erp_system ? '<span>⚙️ ' + p.erp_system + '</span>' : '')
    + (p.start_date ? '<span>🗓 ' + fmtDate(p.start_date) + '</span>' : '')
    + '</div>'
    + (na.fn ? '<div style="margin-top:10px"><button class="btn btn-sm ' + na.cls + '" onclick="event.stopPropagation();' + na.fn + '">' + na.label + '</button></div>' : '')
    + '</div>';
}

async function openProject(id) {
  var detail = document.getElementById('proj-detail');
  var list   = document.getElementById('proj-list');
  if (!detail || !list) return;
  list.style.display = 'none';
  detail.style.display = 'block';
  var r = await api('GET', '/proj/projects/' + id);
  _currentProject = await r.json();
  // Apply tab locks
  _applyTabLocks(_currentProject);
  showProjectTab('overview');
}

function _applyTabLocks(d) {
  var p = d.project || d;
  var isUnlocked = p._is_unlocked || false;
  var lockedTabs = p._locked_tabs || {};

  var allTabs = ['tickets','tasks','meetings','documents','estimate','invoices','files','connections','chat'];
  allTabs.forEach(function(tab) {
    var btn = document.getElementById('ptab-' + tab);
    if (!btn || tab === 'overview' || tab === 'tickets') return; // overview & tickets always accessible

    var shouldLock = !isUnlocked && lockedTabs[tab] === true;
    if (shouldLock) {
      btn.disabled = true;
      btn.title = 'Locked — complete payment for a ticket to unlock';
      btn.style.opacity = '0.4';
      btn.style.cursor = 'not-allowed';
      btn.style.position = 'relative';
      // Add lock icon if not already there
      if (btn.textContent.indexOf('🔒') < 0) btn.textContent = '🔒 ' + btn.textContent;
    } else {
      btn.disabled = false;
      btn.title = '';
      btn.style.opacity = '';
      btn.style.cursor = '';
      btn.textContent = btn.textContent.replace('🔒 ', '');
    }
  });

  // Show unlock banner if locked
  var existingBanner = document.getElementById('proj-lock-banner');
  if (existingBanner) existingBanner.remove();
  if (!isUnlocked) {
    var banner = document.createElement('div');
    banner.id = 'proj-lock-banner';
    banner.style.cssText = 'background:rgba(245,158,11,.06);border:1px solid rgba(245,158,11,.2);border-radius:10px;padding:14px 18px;margin-bottom:16px;display:flex;align-items:center;gap:12px';
    var payMsg = d.project && d.project._payment_status === 'pending'
      ? 'A payment is pending. Complete payment on your ticket to unlock all project features.'
      : 'Create and pay a discovery ticket to unlock all project features.';
    banner.innerHTML = '<span style="font-size:22px">🔒</span>'
      + '<div style="flex:1"><div style="font-weight:700;color:var(--warn);font-size:13px">Project locked — payment required</div>'
      + '<div style="font-size:12px;color:var(--muted);margin-top:2px">' + payMsg + '</div></div>'
      + '<button onclick="showProjectTab(&quot;tickets&quot;)" style="margin-left:8px;padding:7px 16px;background:var(--warn);color:#000;border:none;border-radius:7px;font-size:12px;font-weight:700;cursor:pointer;white-space:nowrap;font-family:inherit">'+(p._payment_status==='pending'?'&#128179; Pay Ticket &#8594;':'&#127891; Create Ticket &#8594;')+'</button>';
    var tabBar = document.getElementById('proj-tab-bar');
    if (tabBar) tabBar.parentNode.insertBefore(banner, tabBar.nextSibling);
  }
}

function closeProjectDetail() {
  document.getElementById('proj-detail').style.display = 'none';
  document.getElementById('proj-list').style.display = 'block';
  destroyChat();
}

// Re-fetch project data then re-render active tab
async function refreshProjectTab(tab) {
  if (!_currentProject || !_currentProject.project) return;
  var pid = _currentProject.project.id;
  try {
    var r = await api('GET', '/proj/projects/' + pid);
    if (r.ok) {
      _currentProject = await r.json();
      _applyTabLocks(_currentProject);
    }
  } catch(e) {}
  showProjectTab(tab || _activeTab || 'overview');
}
var _activeTab = 'overview';

function showProjectTab(tab) {
  _activeTab = tab;
  // Prevent navigating to locked tabs
  var btn = document.getElementById('ptab-' + tab);
  if (btn && btn.disabled && tab !== 'overview' && tab !== 'tickets') {
    toast('🔒 This section is locked. Complete ticket payment to unlock.', 'warn');
    return;
  }

  var tabs = ['overview', 'tickets', 'tasks', 'meetings', 'documents', 'estimate', 'invoices', 'files', 'connections', 'chat'];
  tabs.forEach(function(t) {
    var el  = document.getElementById('pt-' + t);
    var btn2 = document.getElementById('ptab-' + t);
    if (el) el.style.display = t === tab ? 'block' : 'none';
    if (btn2 && !btn2.disabled) btn2.className = 'btn btn-sm ' + (t === tab ? 'btn-primary' : 'btn-outline');
  });
  if (tab === 'chat') {
    var cb = document.getElementById('ptab-chat-badge');
    if (cb) cb.style.display = 'none';
  }
  if (tab === 'tickets') {
    var tb = document.getElementById('ptab-tickets-badge');
    if (tb) tb.style.display = 'none';
  }
  if (!_currentProject) return;
  var d = _currentProject;
  var pid = d.project && d.project.id;
  if (tab === 'overview')    renderProjectOverview(d);
  if (tab === 'tickets')     loadProjectTickets(pid);
  if (tab === 'tasks')       renderTasks(d.tasks || []);
  if (tab === 'meetings')    renderMeetings(d.meetings || []);
  if (tab === 'documents')   loadDocuments(pid);
  if (tab === 'estimate')    loadEstimate(pid);
  if (tab === 'invoices')    loadInvoices(pid);
  if (tab === 'files')       renderFiles(d.files || []);
  if (tab === 'connections') loadConnections(pid);
  if (tab === 'chat')        loadChat(pid);
}

function renderProjectOverview(d) {
  var p = d.project || {};
  var members = d.members || [];
  var manager = members.find(function(m) { return m.role === 'manager'; });
  var consultants = members.filter(function(m) { return m.role === 'consultant'; });
  var el = document.getElementById('pt-overview');
  if (!el) return;
  el.innerHTML = '<div class="card">'
    + '<div class="page-hdr" style="margin-bottom:16px"><div><div class="page-title">' + esc(p.title || '') + '</div>'
    + '<div class="page-sub">' + (p.project_number || '') + (p.erp_system ? ' · ' + p.erp_system : '') + '</div></div>'
    + badge(p.status) + '</div>'
    + '<div style="display:grid;grid-template-columns:1fr 1fr;gap:16px">'
    + '<div>' + [['Status', badge(p.status)], ['ERP System', p.erp_system || '—'], ['Industry', p.industry || '—'], ['Start', fmtDate(p.start_date)], ['End', fmtDate(p.end_date)]].map(function(row) { return '<div class="detail-row"><span class="lbl">' + row[0] + '</span><span class="val">' + row[1] + '</span></div>'; }).join('') + '</div>'
    + '<div><div style="font-size:11px;font-weight:700;color:var(--muted);text-transform:uppercase;margin-bottom:10px">Team</div>'
    + (manager ? '<div class="detail-row"><span class="lbl">ERP Manager</span><span class="val" style="color:var(--gl)">' + esc((manager.pm_users && manager.pm_users.full_name) || 'Assigned') + '</span></div>' : '')
    + consultants.map(function(c, i) { return '<div class="detail-row"><span class="lbl">Consultant ' + (i + 1) + '</span><span class="val">' + esc((c.pm_users && c.pm_users.full_name) || 'Assigned') + '</span></div>'; }).join('')
    + '</div></div>'
    + (p.description ? '<div style="margin-top:16px;padding-top:16px;border-top:1px solid var(--border);font-size:13px;color:var(--muted)">' + esc(p.description) + '</div>' : '')
    + '</div>';
}


// ═══════════════════════════════════════════════════════════════════════════
// PROJECT TICKETS
// ═══════════════════════════════════════════════════════════════════════════

function goToTicketWizard() {
  // Go to the main Tickets section and start the wizard
  goSection('tickets', document.querySelector('[onclick*="goSection(\'tickets\'"]'));
  setTimeout(function(){ startNewTicket(); }, 100);
}

async function submitProjectTicket() {
  var btn = document.getElementById('ntf-btn');
  var msg = document.getElementById('ntf-msg');
  var pid = _currentProject && _currentProject.project && _currentProject.project.id;
  if (!pid) return;

  var date = (document.getElementById('ntf-date') || {}).value;
  var time = (document.getElementById('ntf-time') || {}).value;
  if (!date || !time) {
    if (msg) msg.innerHTML = '<div class="err-msg">Please select a preferred date and time</div>';
    return;
  }

  if (btn) { btn.disabled = true; btn.textContent = 'Submitting...'; }
  if (msg) msg.innerHTML = '';

  var modulesRaw = ((document.getElementById('ntf-modules') || {}).value || '')
    .split(',').map(function(m){ return m.trim(); }).filter(Boolean);

  var r = await api('POST', '/proj/tickets/submit', {
    project_id:         pid,
    erp_system:         (_currentProject && (_currentProject.project || _currentProject).erp_system) || '',
    support_type:       (document.getElementById('ntf-type')     || {}).value || 'discovery',
    priority:           (document.getElementById('ntf-priority') || {}).value || 'medium',
    preferred_date:     date,
    preferred_time:     time,
    preferred_timezone: (document.getElementById('ntf-tz')       || {}).value || 'UTC',
    modules:            modulesRaw,
    description:        (document.getElementById('ntf-desc')     || {}).value || '',
  });
  var d = await r.json().catch(function(){ return {}; });
  if (r.ok) {
    toast('Ticket ' + (d.ticket && d.ticket.ticket_number || '') + ' created!', 'success');
    document.getElementById('new-ticket-form').style.display = 'none';
    ['ntf-date','ntf-time','ntf-modules','ntf-desc'].forEach(function(id){
      var el = document.getElementById(id); if (el) el.value = '';
    });
    loadProjectTickets(pid);
    // Refresh project to update lock state
    var r2 = await api('GET', '/proj/projects/' + pid);
    if (r2.ok) {
      _currentProject = await r2.json();
      _applyTabLocks(_currentProject);
    }
  } else {
    if (msg) msg.innerHTML = '<div class="err-msg">' + esc(d.error || 'Failed to create ticket') + '</div>';
  }
  if (btn) { btn.disabled = false; btn.textContent = 'Submit Ticket →'; }
}

async function loadProjectTickets(projectId) {
  var el = document.getElementById('pt-tickets-list');
  if (!el || !projectId) return;
  el.innerHTML = '<div class="empty"><p>Loading...</p></div>';

  var r = await api('GET', '/proj/projects/' + projectId + '/tickets');
  var d = await r.json().catch(function(){ return {}; });
  var tickets = d.tickets || [];

  if (!tickets.length) {
    el.innerHTML = '<div class="empty">'
      + '<div class="empty-icon">🎫</div>'
      + '<p>No tickets yet.</p>'
      + '<p style="font-size:12px;color:var(--muted);margin-top:8px">Create a ticket to schedule a discovery meeting and unlock project features.</p>'
      + '</div>';
    return;
  }

  el.innerHTML = tickets.map(function(t) {
    var isPaid    = t.payment_status === 'paid';
    var isConf    = ['confirmed','assigned','completed'].includes(t.status);
    var isUnlocked = isPaid && isConf;
    var borderCol = isUnlocked ? 'var(--gl)' : isPaid ? 'var(--warn)' : 'var(--border)';

    return '<div style="background:var(--bg2);border:1px solid var(--border);border-left:4px solid ' + borderCol + ';border-radius:10px;padding:16px;margin-bottom:10px">'
      + '<div style="display:flex;align-items:center;justify-content:space-between;flex-wrap:wrap;gap:10px">'
        + '<div>'
          + '<div style="font-family:monospace;font-weight:800;color:var(--gl);font-size:14px;margin-bottom:4px">' + esc(t.ticket_number || '') + '</div>'
          + '<div style="font-size:12px;color:var(--muted)">'
            + esc(t.support_type || '') + (t.preferred_date ? ' · ' + fmtDate(t.preferred_date) : '')
          + '</div>'
        + '</div>'
        + '<div style="display:flex;align-items:center;gap:8px;flex-wrap:wrap">'
          + badge(t.status)
          + '<span style="font-size:11px;padding:2px 10px;border-radius:10px;background:' + (isPaid ? 'rgba(15,181,116,.1)' : 'rgba(245,158,11,.1)') + ';color:' + (isPaid ? 'var(--gl)' : 'var(--warn)') + ';font-weight:700">'
            + (isPaid ? '✅ Paid' : '💳 Pending Payment')
          + '</span>'
          + (!isPaid ? '<button data-tid="' + t.id + '" onclick="payProjectTicket(this.dataset.tid)" class="btn btn-primary btn-sm" style="font-size:11px">Pay Now &#8594;</button>' : '')
        + '</div>'
      + '</div>'
      + (isUnlocked ? '<div style="margin-top:10px;padding-top:10px;border-top:1px solid var(--border);font-size:12px;color:var(--gl);font-weight:700">🔓 This ticket unlocked project features</div>' : '')
      + (!isPaid ? '<div style="margin-top:10px;font-size:12px;color:var(--muted)">Complete payment to unlock all project tabs and start working with your consultant team.</div>' : '')
    + '</div>';
  }).join('');
}

async function payProjectTicket(ticketId) {
  var r = await api('POST', '/proj/tickets/create-payment', { ticket_id: ticketId });
  var d = await r.json().catch(function(){ return {}; });
  if (r.ok && d.url) window.location.href = d.url;
  else toast('Payment error: ' + (d.error || 'Failed'), 'error');
}

// ── Tasks ─────────────────────────────────────────────────────────────────────

// ═══════════════════════════════════════════════════════════════════════════
// DASHBOARD — Notification Feed & Counters
// ═══════════════════════════════════════════════════════════════════════════

var _NOTIF_ICONS = {
  invoice:        '🧾', estimate: '💰', task: '✅', meeting: '📅',
  document:       '📄', chat: '&#128172;',    ticket: '🎫', project: '📁',
  payment:        '💳', approval: '👍', system: '⚙️', general: '🔔',
  task_submitted: '📋', task_confirmed: '🎉', task_rejected: '&#8617;',
  task_assigned:  '📌', task_cancelled: '❌', invoice_sent: '🧾',
};

async function loadDashboardCounters() {
  try {
    // Fetch all projects for counter data
    var promises = (_projects || []).map(function(p) {
      return api('GET', '/proj/projects/' + p.id).then(function(r){ return r.ok ? r.json() : null; });
    });
    var results = await Promise.all(promises);

    var taskCount = 0, estCount = 0, invCount = 0, meetCount = 0;
    results.forEach(function(d) {
      if (!d) return;
      // Tasks needing client action
      taskCount += (d.tasks||[]).filter(function(t){ return ['submitted','client_testing'].includes(t.status); }).length;
      // Estimates pending approval
      var proj = d.project || {};
      if (proj.status === 'estimated') estCount++;
      // Meetings upcoming
      meetCount += (d.meetings||[]).filter(function(m){
        return m.status !== 'cancelled' && m.scheduled_date && new Date(m.scheduled_date) >= new Date();
      }).length;
    });

    // Invoices due — fetch separately
    if (_projects && _projects.length) {
      var ir = await api('GET', '/proj/projects/' + _projects[0].id + '/invoices');
      if (ir.ok) {
        var id2 = await ir.json();
        invCount = (id2.invoices||[]).filter(function(i){ return ['sent','pending','invoiced'].includes(i.status); }).length;
      }
    }

    var setN = function(id, v) { var el=document.getElementById(id); if(el) el.textContent = v; };
    setN('ov-tasks', taskCount || '—');
    setN('ov-estimates', estCount || '—');
    setN('ov-invoices', invCount || '—');
    var sbInv = document.getElementById('inv-sidebar-badge');
    if (sbInv) { if (invCount > 0) { sbInv.textContent = invCount; sbInv.style.display = 'inline'; } else sbInv.style.display = 'none'; }
    setN('ov-meetings-count', meetCount || '—');

    // Color warn cards
    ['ov-tasks','ov-estimates','ov-invoices'].forEach(function(id) {
      var el = document.getElementById(id);
      if (el) el.style.color = parseInt(el.textContent) > 0 ? 'var(--warn)' : 'var(--gl)';
    });

  } catch(e) { console.warn('[dashCounters]', e); }
}

async function loadNotifFeed() {
  var el = document.getElementById('notif-feed-list');
  if (!el) return;
  try {
    var r = await api('GET', '/proj/notifications?limit=20');
    if (!r.ok) { el.innerHTML = '<div style="padding:20px;color:var(--muted);text-align:center;font-size:13px">Could not load activity</div>'; return; }
    var d = await r.json();
    var notifs = d.notifications || [];

    // Update unread badge
    var unread = notifs.filter(function(n){ return !n.is_read; }).length;
    var unreadEl = document.getElementById('ov-unread');
    if (unreadEl) unreadEl.textContent = unread || '0';
    updateNotifBadge(unread);

    // Update chat tab badge — unread new_message notifications
    var unreadChat = notifs.filter(function(n){ return !n.is_read && (n.type === 'new_message' || n.type === 'chat'); }).length;
    var chatBadge = document.getElementById('ptab-chat-badge');
    if (chatBadge) { chatBadge.textContent = unreadChat; chatBadge.style.display = unreadChat ? 'inline' : 'none'; }

    // Update ticket tab badge — unread ticket notifications
    var unreadTickets = notifs.filter(function(n){ return !n.is_read && (n.type === 'ticket' || n.type === 'ticket_update' || n.type === 'meeting_confirmed'); }).length;
    var tickBadge = document.getElementById('ptab-tickets-badge');
    if (tickBadge) { tickBadge.textContent = unreadTickets; tickBadge.style.display = unreadTickets ? 'inline' : 'none'; }

    if (!notifs.length) {
      el.innerHTML = '<div style="padding:32px;color:var(--muted);text-align:center;font-size:13px">No activity yet</div>';
      return;
    }

    // Build rows via DOM to avoid all nested quote issues
    el.innerHTML = '';
    notifs.forEach(function(n) {
      var icon  = _NOTIF_ICONS[n.type] || '&#128276;';
      var isNew = !n.is_read;
      var time  = n.created_at ? timeAgo(n.created_at) : '';

      var row = document.createElement('div');
      row.dataset.notifId = n.id;
      row.style.cssText = 'display:flex;align-items:flex-start;gap:12px;padding:12px 18px;border-bottom:1px solid var(--border);cursor:pointer;background:' + (isNew ? 'rgba(15,181,116,.03)' : 'transparent');
      var _link = n.link || null;
      row.addEventListener('click', function(){ markNotifRead(n.id, row, _link); });
      row.addEventListener('mouseover', function(){ row.style.background = 'var(--bg3)'; });
      row.addEventListener('mouseout',  function(){ row.style.background = isNew ? 'rgba(15,181,116,.03)' : 'transparent'; });

      var iconEl = document.createElement('div');
      iconEl.style.cssText = 'width:36px;height:36px;border-radius:50%;background:var(--bg3);display:flex;align-items:center;justify-content:center;font-size:16px;flex-shrink:0';
      iconEl.innerHTML = icon;

      var body = document.createElement('div');
      body.style.cssText = 'flex:1;min-width:0';

      // Helper to decode HTML entities from stored notification strings
      var _decodeHtml = function(str) {
        if (!str) return '';
        var txt = document.createElement('textarea');
        txt.innerHTML = str;
        return txt.value;
      };

      var titleEl = document.createElement('div');
      titleEl.style.cssText = 'font-size:13px;font-weight:' + (isNew ? '700' : '500') + ';margin-bottom:2px';
      titleEl.textContent = _decodeHtml(n.title || '');

      body.appendChild(titleEl);
      if (n.body||n.message) {
        var msgEl = document.createElement('div');
        msgEl.style.cssText = 'font-size:12px;color:var(--muted);line-height:1.4';
        msgEl.textContent = _decodeHtml(n.body||n.message);
        body.appendChild(msgEl);
      }
      var timeEl = document.createElement('div');
      timeEl.style.cssText = 'font-size:10px;color:var(--dim);margin-top:4px';
      timeEl.textContent = time;
      body.appendChild(timeEl);

      row.appendChild(iconEl);
      row.appendChild(body);

      if (isNew) {
        var dot = document.createElement('div');
        dot.style.cssText = 'width:8px;height:8px;border-radius:50%;background:var(--gl);flex-shrink:0;margin-top:5px';
        row.appendChild(dot);
      }
      el.appendChild(row);
    });
    // end notif rows
  } catch(e) { console.warn('[loadNotifFeed]', e); }
}

function _taskStatusClr(s) {
  return {pending:'#f59e0b',in_progress:'#60a5fa',submitted:'#a78bfa',client_testing:'#f97316',
          confirmed:'#22c55e',rejected:'#ef4444',completed:'#22c55e'}[s]||'var(--muted)';
}
function _taskClientBadge(cs) {
  if (!cs) return '';
  var clr=cs==='confirmed'?'#22c55e':cs==='rejected'?'#ef4444':'#f97316';
  return '<span style="font-size:10px;padding:2px 8px;border-radius:10px;background:'+clr+'18;color:'+clr+';font-weight:700;border:1px solid '+clr+'33">Client: '+cs.replace(/_/g,' ')+'</span>';
}

function renderTasks(tasks) {
  var el = document.getElementById('pt-tasks-list');
  if (!el) return;
  if (!tasks.length) { el.innerHTML = '<div class="empty"><div class="empty-icon">&#10003;</div><p>No tasks yet</p></div>'; return; }
  el.innerHTML = tasks.map(function(t) {
    var isCompleted = t.status === 'completed' || t.client_status === 'closed';
    var isConfirmed = t.client_status === 'confirmed' || t.client_status === 'closed';
    var canAct      = ['submitted','client_testing'].includes(t.status) && !isConfirmed && !isCompleted;
    var canReport   = !isConfirmed && !isCompleted && !['pending','cancelled'].includes(t.status);
    var stClr       = _taskStatusClr(t.status);
    var startStr    = t.start_date   ? new Date(t.start_date+'T00:00:00').toLocaleDateString('en-GB',{day:'numeric',month:'short',year:'numeric'}) : '';
    var endStr      = t.end_date     ? new Date(t.end_date+'T00:00:00').toLocaleDateString('en-GB',{day:'numeric',month:'short',year:'numeric'}) : '';
    var dueStr      = t.due_date     ? new Date(t.due_date).toLocaleDateString('en-GB',{day:'numeric',month:'short',year:'numeric'}) : '';
    var cmpStr      = t.completed_at ? new Date(t.completed_at).toLocaleDateString('en-GB',{day:'numeric',month:'short',year:'numeric'}) : '';
    var isPastDue   = t.due_date && new Date(t.due_date) < new Date() && t.status !== 'completed';
    var ps          = t.payment_status;

    // Payment banner
    var payBanner = '';
    if (!ps || ps === 'pending') {
      payBanner = '<div style="background:rgba(245,158,11,.08);border:1px solid rgba(245,158,11,.25);border-radius:8px;padding:10px 14px;margin-bottom:10px;display:flex;align-items:center;gap:10px"><span style="font-size:18px">&#128222;</span><div><div style="font-size:12px;font-weight:700;color:var(--warn)">Invoice Pending</div><div style="font-size:11px;color:var(--muted)">An invoice will be created. Payment is required before work begins.</div></div></div>';
    } else if (ps === 'invoiced') {
      payBanner = '<div style="background:rgba(245,158,11,.08);border:1px solid rgba(245,158,11,.25);border-radius:8px;padding:10px 14px;margin-bottom:10px;display:flex;align-items:center;gap:10px"><span style="font-size:18px">&#9203;</span><div><div style="font-size:12px;font-weight:700;color:var(--warn)">Invoice Sent - Payment Required</div><div style="font-size:11px;color:var(--muted)">Please pay the invoice so the consultant can start this task.</div></div></div>';
    } else if (ps === 'paid') {
      payBanner = '<div style="background:rgba(15,181,116,.06);border:1px solid rgba(15,181,116,.2);border-radius:8px;padding:8px 12px;margin-bottom:10px;font-size:12px;color:var(--gl)">&#10003; Invoice paid - consultant can begin work</div>';
    }

    var h = '<div class="task-card" id="task-'+t.id+'" style="border-left:3px solid '+stClr+'">';

    // Header
    h += '<div style="display:flex;justify-content:space-between;align-items:flex-start;margin-bottom:8px;gap:10px">';
    h += '<div style="flex:1;min-width:0"><div style="font-size:14px;font-weight:700;margin-bottom:3px">'+esc(t.title)+'</div>';
    if (t.task_number) h += '<div style="font-size:10px;font-family:monospace;color:var(--muted);background:var(--bg3);border-radius:4px;padding:1px 6px;display:inline-block">'+esc(t.task_number)+'</div>';
    h += '</div><div style="display:flex;gap:6px;flex-wrap:wrap;flex-shrink:0">'+badge(t.status)+_taskClientBadge(t.client_status)+'</div></div>';

    // Meta row
    h += '<div style="display:flex;flex-wrap:wrap;gap:10px;font-size:11px;color:var(--muted);margin-bottom:10px;align-items:center">';
    h += badge(t.priority);
    if (t.estimated_hours) h += '<span>&#9201; '+t.estimated_hours+'h est.</span>';
    if (t.actual_hours)    h += '<span style="color:var(--gl)">&#10003; '+t.actual_hours+'h logged</span>';
    if (startStr) h += '<span>&#128640; Start: '+startStr+'</span>';
    if (endStr)   h += '<span>&#127937; End: '+endStr+'</span>';
    if (dueStr)   h += '<span style="color:'+(isPastDue?'var(--danger)':'var(--warn)')+'">&#128197; Due: '+dueStr+(isPastDue?' (overdue)':'')+'</span>';
    if (cmpStr)   h += '<span style="color:var(--gl)">&#10003; Completed: '+cmpStr+'</span>';
    h += '</div>';

    // Payment banner
    h += payBanner;

    // Assigned person
    if (t.assigned_to_name) {
      var isCons = t.assigned_to_role === 'consultant';
      var aClr   = isCons ? '#60a5fa' : '#f59e0b';
      h += '<div style="display:flex;align-items:center;gap:10px;padding:10px 12px;background:var(--bg2);border-radius:8px;margin-bottom:10px">';
      h += '<div style="width:36px;height:36px;border-radius:50%;background:'+aClr+'1a;color:'+aClr+';display:flex;align-items:center;justify-content:center;font-weight:800;font-size:15px;flex-shrink:0">'+esc(t.assigned_to_name.charAt(0).toUpperCase())+'</div>';
      h += '<div><div style="font-size:10px;font-weight:700;text-transform:uppercase;color:var(--muted);margin-bottom:2px">'+(isCons?'Your Consultant':'ERP Manager')+'</div>';
      h += '<div style="font-size:13px;font-weight:700;color:'+aClr+'">'+esc(t.assigned_to_name)+'</div>';
      if (t.assigned_to_email) h += '<div style="font-size:11px;color:var(--muted)">'+esc(t.assigned_to_email)+'</div>';
      h += '</div></div>';
    }

    // Description
    if (t.description) h += '<div style="font-size:13px;color:var(--muted);margin-bottom:10px;line-height:1.6">'+esc(t.description)+'</div>';

    // Requirements
    if (t.requirements) {
      h += '<div style="background:rgba(10,76,204,.06);border-left:3px solid rgba(10,76,204,.3);padding:10px 12px;border-radius:0 8px 8px 0;margin-bottom:10px">';
      h += '<div style="font-size:10px;font-weight:700;text-transform:uppercase;color:#60a5fa;margin-bottom:5px">Scope &amp; Requirements</div>';
      h += '<div style="font-size:12px;line-height:1.6;color:var(--text)">'+esc(t.requirements)+'</div></div>';
    }

    // Admin notes
    if (t.admin_notes) {
      h += '<div style="background:rgba(99,102,241,.06);border-left:3px solid rgba(99,102,241,.3);padding:10px 12px;border-radius:0 8px 8px 0;margin-bottom:10px">';
      h += '<div style="font-size:10px;font-weight:700;text-transform:uppercase;color:#818cf8;margin-bottom:5px">Admin Note</div>';
      h += '<div style="font-size:12px;line-height:1.6;color:var(--text)">'+esc(t.admin_notes)+'</div></div>';
    }

    // Client notes
    if (t.client_notes) {
      h += '<div style="background:rgba(245,158,11,.06);border-left:3px solid rgba(245,158,11,.3);padding:8px 12px;border-radius:0 8px 8px 0;margin-bottom:10px">';
      h += '<div style="font-size:10px;font-weight:700;text-transform:uppercase;color:var(--warn);margin-bottom:3px">Your Feedback</div>';
      h += '<div style="font-size:12px;color:var(--text)">'+esc(t.client_notes)+'</div></div>';
    }

    // ── Task status banners and client actions ───────────────────────────────
    if (t.status === 'cancelled') {
      h += '<div style="background:rgba(224,82,82,.06);border:1px solid rgba(224,82,82,.2);border-radius:8px;padding:10px 14px;margin-bottom:8px">';
      h += '<div style="font-size:13px;font-weight:700;color:var(--danger)">&#10060; Task Cancelled</div>';
      if (t.admin_notes && t.admin_notes.includes('[Cancelled')) {
        var cancelNote = t.admin_notes.split(']:').pop().trim();
        h += '<div style="font-size:11px;color:var(--muted);margin-top:3px">'+esc(cancelNote)+'</div>';
      }
      h += '</div>';
    } else if (isCompleted) {
      h += '<div style="background:rgba(15,181,116,.08);border:1px solid rgba(15,181,116,.25);border-radius:8px;padding:12px 16px;margin-bottom:8px;display:flex;align-items:center;gap:12px">';
      h += '<span style="font-size:24px">&#127881;</span>';
      h += '<div><div style="font-size:13px;font-weight:700;color:var(--gl)">Task Completed &amp; Confirmed</div>';
      h += '<div style="font-size:11px;color:var(--muted);margin-top:2px">Great work! The consultant has been credited for this task.</div></div></div>';
    } else if (t.status === 'submitted' && !isConfirmed) {
      h += '<div style="padding:14px;background:rgba(167,139,250,.04);border:1px solid rgba(167,139,250,.2);border-radius:8px;margin-bottom:8px">';
      h += '<div style="font-size:12px;font-weight:700;color:#a78bfa;margin-bottom:6px">&#128228; Awaiting Your Review</div>';
      h += '<div style="font-size:12px;color:var(--muted);margin-bottom:10px">The consultant has submitted this task. Please review and confirm or request changes.</div>';
      h += '<div style="display:flex;gap:8px;flex-wrap:wrap">';
      h += '<button class="btn btn-confirm btn-sm" data-id="'+t.id+'" onclick="updateTask(this.dataset.id,\'confirmed\')">&#10003; Confirm Completed</button>';
      h += '<button class="btn btn-reject btn-sm" data-id="'+t.id+'" onclick="toggleRejectForm(this.dataset.id)">&#10007; Request Revision</button>';
      h += '</div></div>';
    } else if (t.status === 'in_progress') {
      h += '<div style="font-size:11px;color:#60a5fa;background:rgba(96,165,250,.06);border:1px solid rgba(96,165,250,.15);border-radius:8px;padding:8px 12px;margin-bottom:8px">';
      h += '&#9881; Consultant is working on this task&hellip;</div>';
    } else if (t.status === 'rejected') {
      h += '<div style="font-size:11px;color:var(--warn);background:rgba(245,158,11,.06);border:1px solid rgba(245,158,11,.2);border-radius:8px;padding:8px 12px;margin-bottom:8px">';
      h += '&#128260; Revision requested &#8212; consultant is reworking this task.</div>';
    } else if (t.status === 'pending') {
      if (ps === 'invoiced') {
        h += '<div style="font-size:11px;color:var(--warn);background:rgba(245,158,11,.06);border:1px solid rgba(245,158,11,.2);border-radius:8px;padding:8px 12px;margin-bottom:8px">';
        h += '&#9203; Invoice sent &#8212; payment required before work begins.</div>';
      } else if (ps === 'paid' || ps === 'no_invoice') {
        h += '<div style="font-size:11px;color:#60a5fa;background:rgba(96,165,250,.06);border:1px solid rgba(96,165,250,.15);border-radius:8px;padding:8px 12px;margin-bottom:8px">';
        h += '&#9989; Payment received &#8212; waiting for consultant to start.</div>';
      }
    }

    // Reject form
    h += '<div id="rf-'+t.id+'" style="display:none;margin-bottom:8px">';
    h += '<textarea class="ftextarea" id="rn-'+t.id+'" rows="3" placeholder="Please describe what needs to be revised..." style="margin-bottom:8px;width:100%;box-sizing:border-box"></textarea>';
    h += '<button class="btn btn-reject btn-sm" onclick="submitReject(this.dataset.id)" data-id="'+t.id+'">Submit Revision Request</button>';
    h += '</div>';

    // Report issue
    if (canReport) {
      h += '<div style="display:flex;justify-content:flex-end;margin-top:8px;padding-top:8px;border-top:1px solid var(--border)">';
      h += '<button class="btn btn-outline btn-sm" style="color:var(--warn);border-color:var(--warn);font-size:11px" onclick="openTaskReport(this.dataset.id,this.dataset.title)" data-id="'+t.id+'" data-title="'+esc(t.title)+'">&#9888; Report Issue</button>';
      h += '</div>';
    }

    h += '</div>';
    return h;
  }).join('');
}


function toggleRejectForm(id) {
  var el = document.getElementById('rf-' + id);
  if (el) el.style.display = el.style.display === 'block' ? 'none' : 'block';
}
// ── Task Report Modal ─────────────────────────────────────────────────────────
var _reportTaskId = null;
function openTaskReport(taskId, taskTitle) {
  _reportTaskId = taskId;
  var existing = document.getElementById('task-report-modal');
  if (existing) existing.remove();
  var modal = document.createElement('div');
  modal.id = 'task-report-modal';
  modal.style.cssText = 'position:fixed;inset:0;background:rgba(0,0,0,.6);z-index:9000;display:flex;align-items:center;justify-content:center;padding:16px';
  modal.innerHTML =
    '<div style="background:var(--bg2);border:1px solid var(--border);border-radius:14px;padding:24px;max-width:460px;width:100%;box-shadow:0 20px 60px rgba(0,0,0,.4)">'
    +'<div style="display:flex;align-items:center;justify-content:space-between;margin-bottom:16px">'
    +  '<div style="font-weight:800;font-size:16px">⚠️ Report Issue</div>'
    +  '<button onclick="closeTaskReport()" style="background:none;border:none;color:var(--muted);font-size:20px;cursor:pointer;padding:0 4px">✕</button>'
    +'</div>'
    +'<div style="font-size:12px;color:var(--muted);margin-bottom:16px">Task: <b>'+taskTitle+'</b></div>'
    +'<div style="margin-bottom:14px">'
    +  '<label style="font-size:12px;font-weight:700;color:var(--muted);text-transform:uppercase;letter-spacing:.05em;display:block;margin-bottom:8px">Issue Type</label>'
    +  '<div style="display:flex;gap:8px;flex-wrap:wrap">'
    +    '<button class="report-type-btn active" data-type="late" onclick="selectReportType(this)" style="flex:1;padding:10px 8px;border-radius:8px;border:2px solid var(--gl);background:rgba(15,181,116,.1);color:var(--gl);cursor:pointer;font-weight:700;font-size:12px;min-width:80px">⏰ Late</button>'
    +    '<button class="report-type-btn" data-type="cancel" onclick="selectReportType(this)" style="flex:1;padding:10px 8px;border-radius:8px;border:2px solid var(--border);background:none;color:var(--muted);cursor:pointer;font-weight:600;font-size:12px;min-width:80px">🚫 Cancel</button>'
    +    '<button class="report-type-btn" data-type="refund" onclick="selectReportType(this)" style="flex:1;padding:10px 8px;border-radius:8px;border:2px solid var(--border);background:none;color:var(--muted);cursor:pointer;font-weight:600;font-size:12px;min-width:80px">💰 Refund</button>'
    +  '</div>'
    +'</div>'
    +'<div style="margin-bottom:16px">'
    +  '<label style="font-size:12px;font-weight:700;color:var(--muted);text-transform:uppercase;letter-spacing:.05em;display:block;margin-bottom:6px">Comment</label>'
    +  '<textarea id="task-report-comment" class="ftextarea" rows="4" placeholder="Describe the issue in detail..." style="width:100%;box-sizing:border-box"></textarea>'
    +'</div>'
    +'<div id="task-report-msg" style="margin-bottom:10px"></div>'
    +'<div style="display:flex;gap:10px">'
    +  '<button class="btn btn-outline btn-sm" onclick="closeTaskReport()" style="flex:1">Cancel</button>'
    +  '<button id="task-report-submit" class="btn btn-primary btn-sm" onclick="submitTaskReport()" style="flex:1;background:var(--warn);border-color:var(--warn)">⚠️ Submit Report</button>'
    +'</div>'
    +'</div>';
  document.body.appendChild(modal);
  modal.addEventListener('click', function(e){ if (e.target===modal) closeTaskReport(); });
}
function selectReportType(btn) {
  document.querySelectorAll('.report-type-btn').forEach(function(b){ b.style.border='2px solid var(--border)'; b.style.background='none'; b.style.color='var(--muted)'; });
  btn.style.border='2px solid var(--gl)'; btn.style.background='rgba(15,181,116,.1)'; btn.style.color='var(--gl)';
}
function closeTaskReport() {
  var m=document.getElementById('task-report-modal'); if(m) m.remove(); _reportTaskId=null;
}
async function submitTaskReport() {
  if (!_reportTaskId) return;
  var actionBtn = document.querySelector('.report-type-btn[style*="var(--gl)"]');
  var action  = actionBtn ? actionBtn.dataset.type : 'late';
  var comment = (document.getElementById('task-report-comment')||{}).value||'';
  if (!comment.trim()) { document.getElementById('task-report-msg').innerHTML='<span style="color:var(--danger);font-size:12px">Please describe the issue</span>'; return; }
  var btn=document.getElementById('task-report-submit'); if(btn){btn.disabled=true;btn.textContent='Submitting...';}
  var r = await api('POST','/proj/tasks/'+_reportTaskId+'/report',{action,comment:comment.trim()});
  var d = await r.json().catch(function(){return{};});
  if (r.ok) {
    document.getElementById('task-report-msg').innerHTML='<span style="color:var(--gl);font-size:12px">✅ Report submitted. Our team will review it shortly.</span>';
    setTimeout(function(){ closeTaskReport(); refreshProjectTab('tasks'); }, 1500);
  } else {
    document.getElementById('task-report-msg').innerHTML='<span style="color:var(--danger);font-size:12px">'+esc(d.error||'Failed to submit')+'</span>';
    if(btn){btn.disabled=false;btn.textContent='⚠️ Submit Report';}
  }
}



async function updateTask(taskId, status, notes) {
  var r = await api('PUT', '/proj/tasks/' + taskId + '/status', { status: status, client_notes: notes || null });
  var d = await r.json().catch(function(){ return {}; });
  if (r.ok) {
    var el = document.getElementById('task-' + taskId);
    if (el) { el.style.opacity = '.5'; el.style.transition = '.4s'; }
    toast('Updated ✅', 'ok');
    setTimeout(function() { refreshProjectTab('tasks'); }, 500);
  } else {
    var msg = d.error || ('HTTP ' + r.status);
    console.error('[updateTask] failed:', r.status, msg);
    toast('Failed: ' + msg, 'err');
  }
}

async function submitReject(taskId) {
  var notes = (document.getElementById('rn-' + taskId) || {}).value || '';
  if (!notes.trim()) { toast('Please provide a reason', 'err'); return; }
  await updateTask(taskId, 'rejected', notes);
}

// ── Meetings ──────────────────────────────────────────────────────────────────
function renderMeetings(meetings) {
  var el = document.getElementById('pt-meetings-list');
  if (!el) return;
  if (!meetings.length) { el.innerHTML = '<div class="empty"><div class="empty-icon">📅</div><p>No meetings yet</p></div>'; return; }
  el.innerHTML = meetings.map(meetingItemHtml).join('');
}

function _clUserTz() {
  return (USER && USER.timezone) || Intl.DateTimeFormat().resolvedOptions().timeZone || 'UTC';
}

function _clFmtTime(raw, srcTz) {
  if (!raw) return '';
  var useTz = _clUserTz();
  var clean = String(raw).trim();
  var mx = clean.match(/^(\d{1,2}:\d{2})/);
  if (!mx) return clean;
  var parts = mx[1].split(':');
  var h = parseInt(parts[0], 10), mi = parseInt(parts[1], 10);
  if (isNaN(h) || isNaN(mi)) return clean;

  // No srcTz — display raw time with user's tz label (no conversion)
  if (!srcTz) {
    try {
      var n0 = new Date();
      var td0 = n0.getFullYear()+'-'+String(n0.getMonth()+1).padStart(2,'0')+'-'+String(n0.getDate()).padStart(2,'0');
      var d0 = new Date(td0+'T'+String(h).padStart(2,'0')+':'+String(mi).padStart(2,'0')+':00');
      return new Intl.DateTimeFormat('en-US',{timeZone:useTz,hour:'numeric',minute:'2-digit',hour12:true,timeZoneName:'short'}).format(d0);
    } catch(e) {
      var a0 = h>=12?'PM':'AM';
      return (h%12||12)+':'+String(mi).padStart(2,'0')+' '+a0;
    }
  }

  try {
    var _now = new Date();
    var _today = _now.getFullYear() + '-' + String(_now.getMonth()+1).padStart(2,'0') + '-' + String(_now.getDate()).padStart(2,'0');
    var d = new Date(_today + 'T' + String(h).padStart(2,'0') + ':' + String(mi).padStart(2,'0') + ':00Z');
    var srcFmt = new Intl.DateTimeFormat('en-CA', {
      timeZone: srcTz, hour: '2-digit', minute: '2-digit', hour12: false
    }).format(d);
    var sp = srcFmt.replace(',','').trim().split(':');
    var srcH = parseInt(sp[0] === '24' ? '0' : sp[0], 10);
    var srcM = parseInt(sp[1], 10);
    var diffMin = (h - srcH) * 60 + (mi - srcM);
    var utcDate = new Date(d.getTime() + diffMin * 60000);
    return new Intl.DateTimeFormat('en-US', {
      timeZone: useTz, hour: 'numeric', minute: '2-digit', hour12: true, timeZoneName: 'short'
    }).format(utcDate);
  } catch(e) {
    var ampm = h >= 12 ? 'PM' : 'AM';
    return (h % 12 || 12) + ':' + String(mi).padStart(2,'0') + ' ' + ampm;
  }
}

function meetingItemHtml(m) {
  var isDiscovery = m._type === 'discovery' || m._source === 'discovery';
  var isConfirmed = m.status === 'confirmed' || m.status === 'rescheduled';
  var title       = isDiscovery ? '🔍 Discovery Meeting' : esc(m.title||'Meeting');
  var dateField   = m.scheduled_date || m.meeting_date || m.date || '';
  var timeField   = m.scheduled_time || m.meeting_time || m.time || '';
  var link        = m.meeting_link || m.link || '';
  var _pLabels    = { daily:'⚡ EOH Room', livekit:'⚡ EOH Room', jitsi:'Jitsi Meet', meet:'Google Meet', zoom:'Zoom', zoho:'Zoho Meeting', gmeet:'Google Meet' };
  var platform    = (function(p){ return p ? (_pLabels[p] || p) : ''; })(m.platform || m.meeting_platform || '');
  var consultant  = m.consultant_name ? ('<span style="font-size:11px;color:var(--muted)">👤 ' + esc(m.consultant_name) + '</span>') : '';

  // Ticket / meeting details
  var ticketNum   = m.ticket_number || '';
  var erpSystem   = m.erp_system || '';
  var suppType    = m.support_type || '';
  var modules     = Array.isArray(m.modules) ? m.modules.join(', ') : (m.modules || '');
  var detailsHtml = '';
  if (ticketNum || erpSystem || suppType || modules) {
    detailsHtml = '<div style="display:flex;flex-wrap:wrap;gap:6px;margin-top:6px">'
      + (ticketNum ? '<span style="font-family:monospace;font-size:11px;font-weight:700;padding:2px 8px;border-radius:6px;background:rgba(15,181,116,.08);color:var(--gl);border:1px solid rgba(15,181,116,.2)">' + esc(ticketNum) + '</span>' : '')
      + (erpSystem ? '<span style="font-size:11px;padding:2px 8px;border-radius:6px;background:var(--bg3);border:1px solid var(--border);color:var(--muted)">⚙️ ' + esc(erpSystem) + '</span>' : '')
      + (suppType  ? '<span style="font-size:11px;padding:2px 8px;border-radius:6px;background:var(--bg3);border:1px solid var(--border);color:var(--muted)">🔧 ' + esc(suppType) + '</span>' : '')
      + (modules   ? '<span style="font-size:11px;padding:2px 8px;border-radius:6px;background:var(--bg3);border:1px solid var(--border);color:var(--muted)">📦 ' + esc(modules) + '</span>' : '')
      + '</div>';
  }

  var nowMs   = Date.now();
  var todayLocal = new Date().toLocaleDateString('en-CA'); // YYYY-MM-DD
  var isPastM = false, isLiveM = false;
  var meetMs = 0;
  if (dateField) {
    var isToday2 = (dateField === todayLocal || dateField === new Date().toISOString().split('T')[0]);
    if (timeField) {
      var tC = String(timeField).match(/^(\d{1,2}:\d{2})/);
      if (tC) { try { meetMs = new Date(dateField + 'T' + tC[1] + ':00').getTime(); } catch(e) {} }
    }
    isPastM = meetMs > 0 && nowMs > meetMs + 3600000 && !isToday2;
    isLiveM = isToday2 || (meetMs > 0 && nowMs >= meetMs - 15*60*1000 && nowMs <= meetMs + 3600000);
  }

  var srcTzM  = m.timezone || m.preferred_timezone || null;
  var timeFmt = timeField ? _clFmtTime(timeField, srcTzM) : '';

  // Join button: 15min before → 1h after start
  var joinBtn = '';
  if (isConfirmed && link) {
    if (isLiveM) {
      var _cp = _currentProject && _currentProject.project ? _currentProject.project : {};
      var clMeetParams = new URLSearchParams({
        platform: m._platform || m.platform || 'jitsi',
        link:     link,
        name:     (window.USER && window.USER.full_name) ? window.USER.full_name : 'Client',
        company:  m.company || m._proj_title || _cp.title || '',
        ticket:   m.ticket_number || '',
        erp:      m.erp_system || _cp.erp_system || '',
        dtype:    m.support_type || '',
        date:     dateField || '',
      });
      joinBtn = '<a href="/pages/eoh-meeting-room?' + clMeetParams.toString() + '" class="btn btn-primary btn-sm" style="animation:pulse 2s infinite">⚡ Join EOH Room</a>';
    } else if (!isPastM && meetMs > 0) {
      var diffMs2 = meetMs - Date.now();
      var hh=Math.floor(diffMs2/3600000), mm2=Math.floor((diffMs2%3600000)/60000);
      joinBtn = '<span style="font-size:11px;color:var(--warn);font-weight:700">⏳ Opens in ' + (hh>0?hh+'h ':'')+mm2+'m</span>';
    }
  }

  var pastBadge = isPastM ? '<span style="font-size:10px;padding:2px 8px;border-radius:6px;background:rgba(15,181,116,.08);border:1px solid rgba(15,181,116,.2);color:var(--gl);font-weight:700;letter-spacing:.05em">✅ Completed</span>' : '';
  var projName  = m.project_title || m._proj_title || '';
  var isPending = !isDiscovery && m.status === 'pending_confirmation' && m.confirmation_required_from === 'client';

  return '<div class="meeting-item" style="border-left:3px solid '+(isLiveM?'var(--gl)':isPastM?'rgba(15,181,116,.3)':isDiscovery?'var(--gl)':'var(--border)')+';opacity:'+(isPastM?'0.6':'1')+'">'
    + '<div class="meeting-info">'
    + (projName ? '<div style="font-size:10px;font-weight:700;color:var(--gl);text-transform:uppercase;letter-spacing:.05em;margin-bottom:4px">📁 ' + esc(projName) + '</div>' : '')
    + '<div class="m-title" style="display:flex;align-items:center;gap:8px">' + title
    + (isDiscovery ? '<span style="font-size:10px;padding:2px 8px;border-radius:10px;background:rgba(15,181,116,.1);color:var(--gl);font-weight:700">' + (isPastM?'✅ Completed':isConfirmed?'✅ Confirmed':'⏳ Awaiting') + '</span>' : '')
    + '</div>'
    + '<div class="m-meta">'
    + '<span style="display:inline-flex;align-items:center;gap:5px;background:rgba(15,181,116,.1);border:1px solid rgba(15,181,116,.25);color:var(--gl);font-size:12px;font-weight:800;padding:4px 10px;border-radius:8px">📅 ' + (dateField||'TBD') + '</span>'
    + (timeFmt ? '<span style="display:inline-flex;align-items:center;gap:5px;background:rgba(10,76,204,.15);border:1px solid rgba(10,76,204,.35);color:#60a5fa;font-size:12px;font-weight:800;padding:4px 10px;border-radius:8px">🕐 ' + esc(timeFmt) + '</span>' : '')
    + (platform   ? '<span>💻 ' + esc(platform) + '</span>' : '')
    + '</div>'
    + detailsHtml
    + (consultant ? '<div style="margin-top:4px">' + consultant + '</div>' : '')
    + '</div>'
    + '<div style="display:flex;gap:8px;align-items:center;flex-wrap:wrap">'
    + pastBadge
    + (!isDiscovery ? badge(isPastM ? 'past' : isPending ? 'pending' : m.status) : '')
    + joinBtn
    + (isPending && !isPastM ? '<button class="btn btn-confirm btn-sm" onclick="confirmMeeting(\'' + m.id + '\',\'confirm\')">✅ Confirm</button><button class="btn btn-reject btn-sm" onclick="confirmMeeting(\'' + m.id + '\',\'decline\')">❌ Decline</button>' : '')
    + '</div></div>';
}

async function confirmMeeting(id, action) {
  var r = await api('PUT', '/proj/meetings/' + id + '/confirm', { action: action });
  if (r.ok) {
    toast(action === 'confirm' ? '✅ Meeting confirmed — team notified' : 'Meeting declined');
    // Auto-refresh current view
    if (_currentProject && _currentProject.project && _currentProject.project.id) {
      showProjectTab('meetings');
    } else {
      loadGlobalMeetings();
    }
  } else { toast('Failed to update meeting', 'error'); }
}

function openMeetingForm() {
  // Must be inside a project to schedule a meeting
  var pid = _currentProject && _currentProject.project && _currentProject.project.id;
  if (!pid) {
    // Show message asking user to open a project first
    var formEl = document.getElementById('meeting-form');
    if (formEl) {
      formEl.style.display = 'block';
      var msgEl = document.getElementById('meeting-form-msg');
      if (msgEl) msgEl.innerHTML = '<div class="err-msg" style="margin-bottom:12px">⚠️ Please open a project first from My Projects, then request a meeting from within that project.</div>';
    }
    return;
  }

  document.getElementById('meeting-form').style.display = 'block';
  document.getElementById('meeting-form').scrollIntoView({ behavior: 'smooth', block: 'start' });
  document.getElementById('meeting-form-msg').innerHTML = '';
  var now = new Date();
  // Auto-set date to today
  var mfDate = document.getElementById('mf-date');
  if (mfDate) {
    mfDate.min   = now.toLocaleDateString('en-CA');
    mfDate.value = now.toLocaleDateString('en-CA');
  }
  // Auto-set time to current time rounded to next 5 min
  var mfTime = document.getElementById('mf-time');
  if (mfTime) {
    var mins = now.getMinutes();
    var roundedMins = Math.ceil(mins / 5) * 5;
    var adjHour = now.getHours() + Math.floor(roundedMins / 60);
    mfTime.value = String(adjHour % 24).padStart(2,'0') + ':' + String(roundedMins % 60).padStart(2,'0');
  }
  // Auto-set timezone
  try { document.getElementById('mf-tz').value = Intl.DateTimeFormat().resolvedOptions().timeZone; } catch(e) {}
  // Load attendees for current project
  loadClientMeetingAttendees(pid);
}

async function loadClientMeetingAttendees(pid) {
  var listEl = document.getElementById('mf-attendees-list');
  var hint   = document.getElementById('mf-attendees-hint');
  if (!listEl || !pid) return;
  listEl.innerHTML = '<div style="font-size:12px;color:var(--muted);padding:4px">Loading members…</div>';
  try {
    var r = await api('GET', '/proj/projects/' + pid + '/members');
    var d = await r.json();
    var people = d.people || [];
    if (!people.length) { listEl.innerHTML = '<div style="font-size:12px;color:var(--muted);padding:4px">No members found</div>'; return; }
    if (hint) hint.textContent = people.length + ' members — all selected';
    var roleColors = { client:'#60a5fa', consultant:'var(--gl)', manager:'#a78bfa', erpm:'#a78bfa', pm:'#a78bfa' };
    var roleLabels = { client:'Client', consultant:'Consultant', manager:'ERP Manager', erpm:'ERP Manager', pm:'ERP Manager' };
    listEl.innerHTML = people.map(function(p) {
      var rColor = roleColors[p.role] || 'var(--muted)';
      var rLabel = roleLabels[p.role] || p.role;
      return '<label style="display:flex;align-items:center;gap:10px;padding:7px 8px;border-radius:6px;cursor:pointer">'
        + '<input type="checkbox" checked data-id="' + esc(String(p.id||'')) + '" data-name="' + esc(p.name) + '" data-email="' + esc(p.email) + '" data-role="' + esc(p.role) + '" style="width:15px;height:15px;accent-color:var(--gl);flex-shrink:0">'
        + '<div style="flex:1;font-size:13px;font-weight:600">' + esc(p.name) + '</div>'
        + '<span style="font-size:10px;padding:2px 8px;border-radius:10px;background:' + rColor + '22;color:' + rColor + ';font-weight:700;flex-shrink:0">' + esc(rLabel) + '</span>'
        + '</label>';
    }).join('');
  } catch(e) { listEl.innerHTML = '<div style="font-size:12px;color:var(--danger);padding:4px">Error loading members</div>'; }
}

async function submitMeeting() {
  var msgEl = document.getElementById('meeting-form-msg');
  var title = (document.getElementById('mf-title') || {}).value || '';
  var date  = (document.getElementById('mf-date') || {}).value || '';
  var time  = (document.getElementById('mf-time') || {}).value || '';
  var tz    = (document.getElementById('mf-tz') || {}).value || 'UTC';
  if (!title) { msgEl.innerHTML = '<div class="err-msg">Title required</div>'; return; }
  if (!date || !time) { msgEl.innerHTML = '<div class="err-msg">Date and time required</div>'; return; }
  var pid = _currentProject && _currentProject.project && _currentProject.project.id;
  if (!pid) { msgEl.innerHTML = '<div class="err-msg">No project selected — please open a project first</div>'; return; }

  // Collect selected attendees (may be empty if still loading — that's OK, backend will email all members)
  var attendees = [];
  document.querySelectorAll('#mf-attendees-list input[type="checkbox"]:checked').forEach(function(cb) {
    attendees.push({ id: cb.dataset.id, name: cb.dataset.name, email: cb.dataset.email, role: cb.dataset.role });
  });

  msgEl.innerHTML = '<div style="font-size:12px;color:var(--muted)">Submitting…</div>';
  var r = await api('POST', '/proj/projects/' + pid + '/meetings', {
    title: title, scheduled_date: date, scheduled_time: time, timezone: tz,
    agenda: (document.getElementById('mf-agenda') || {}).value || '',
    attendees: attendees.length ? attendees : null
  });
  if (r.ok) {
    document.getElementById('meeting-form').style.display = 'none';
    msgEl.innerHTML = '';
    toast('✅ Meeting requested — emails sent to team');
    showProjectTab('meetings');
  } else {
    var d = await r.json();
    msgEl.innerHTML = '<div class="err-msg">❌ ' + (d.error || 'Failed to create meeting') + '</div>';
  }
}

// ── Documents ─────────────────────────────────────────────────────────────────
async function loadDocuments(projectId) {
  var el = document.getElementById('pt-documents-list');
  if (!el) return;
  el.innerHTML = '<div class="empty"><div class="empty-icon">⏳</div>Loading...</div>';
  try {
    var r = await api('GET', '/proj/projects/' + projectId + '/documents');
    var d = await r.json();
    var docs = d.documents || [];
    if (!docs.length) {
      el.innerHTML = '<div class="card"><div class="empty"><div class="empty-icon">📄</div><p style="font-weight:600;margin-bottom:6px">No documents yet</p><p style="font-size:12px;color:var(--muted)">Your consultant will upload a plan document after the discovery meeting. You\'ll be notified when it\'s ready for review.</p></div></div>';
      return;
    }
    el.innerHTML = docs.map(function(doc) {
      var sc = { submitted: 'doc-pending', client_approved: 'doc-approved', client_rejected: 'doc-rejected' }[doc.status] || '';
      var sb = { draft: badge('draft', 'b-draft'), submitted: badge('pending review', 'b-submitted'), client_approved: badge('approved', 'b-active'), client_rejected: badge('rejected', 'b-rejected') }[doc.status] || badge(doc.status || '');
      var canAct = doc.status === 'submitted';
      return '<div class="doc-card ' + sc + '" id="doc-' + doc.id + '">'
        + '<div style="display:flex;justify-content:space-between;align-items:flex-start;gap:12px;margin-bottom:10px">'
        + '<div style="display:flex;gap:12px;align-items:flex-start"><div style="font-size:28px">📄</div>'
        + '<div><div style="font-size:14px;font-weight:700;margin-bottom:3px">' + esc(doc.title || 'Plan Document') + '</div>'
        + '<div style="font-size:12px;color:var(--muted);display:flex;gap:12px;flex-wrap:wrap">'
        + (doc.doc_type ? '<span>📌 ' + doc.doc_type.replace(/_/g, ' ') + '</span>' : '')
        + (doc.uploaded_by_name ? '<span>👤 ' + esc(doc.uploaded_by_name) + '</span>' : '')
        + '<span>🗓 ' + fmtDate(doc.created_at) + '</span></div></div></div>'
        + '<div style="flex-shrink:0">' + sb + '</div></div>'
        + (doc.description ? '<div style="font-size:13px;color:var(--muted);line-height:1.6;margin-bottom:12px;padding:10px 12px;background:var(--bg3);border-radius:7px">' + esc(doc.description) + '</div>' : '')
        + '<div style="display:flex;gap:8px;align-items:center;flex-wrap:wrap">'
        + (doc.file_url ? '<a href="' + doc.file_url + '" target="_blank" class="btn btn-outline btn-sm">↓ Download</a>' : '')
        + (canAct ? '<button class="btn btn-confirm btn-sm" onclick="respondDoc(\'' + doc.id + '\',\'approved\')">✅ Approve Plan</button><button class="btn btn-reject btn-sm" onclick="showDocReject(\'' + doc.id + '\')">❌ Request Changes</button>' : '')
        + '</div>'
        + '<div id="doc-rf-' + doc.id + '" style="display:none;margin-top:12px">'
        + '<div class="fgrp"><label class="flbl">Your feedback / change requests</label><textarea class="ftextarea" id="doc-rn-' + doc.id + '" rows="3" placeholder="Describe the changes needed..."></textarea></div>'
        + '<div style="display:flex;gap:8px"><button class="btn btn-reject btn-sm" onclick="respondDoc(\'' + doc.id + '\',\'rejected\')">Submit Rejection</button><button class="btn btn-outline btn-sm" onclick="hideDocReject(\'' + doc.id + '\')">Cancel</button></div>'
        + '</div></div>';
    }).join('');
  } catch(e) {
    el.innerHTML = '<div class="err-msg">❌ Could not load documents</div>';
  }
}

function showDocReject(id) { var el = document.getElementById('doc-rf-' + id); if (el) el.style.display = 'block'; }
function hideDocReject(id) { var el = document.getElementById('doc-rf-' + id); if (el) el.style.display = 'none'; }

async function respondDoc(docId, action) {
  var notes = '';
  if (action === 'rejected') {
    notes = ((document.getElementById('doc-rn-' + docId) || {}).value || '').trim();
    if (!notes) { toast('Please describe the changes needed', 'err'); return; }
  }
  var r = await api('PUT', '/proj/documents/' + docId, { action: action, client_notes: notes });
  if (r.ok) {
    toast(action === 'approved' ? '✅ Plan document approved!' : '📝 Change request submitted');
    loadDocuments(_currentProject && _currentProject.project && _currentProject.project.id);
  } else {
    var d = await r.json();
    toast('❌ ' + (d.error || 'Action failed'), 'err');
  }
}

// ── Estimate ──────────────────────────────────────────────────────────────────
async function loadEstimate(projectId) {
  var el = document.getElementById('pt-estimate-content');
  if (!el) return;
  el.innerHTML = '<div class="empty"><div class="empty-icon">⏳</div>Loading...</div>';
  var r = await api('GET', '/proj/projects/' + projectId + '/estimates');
  var d = await r.json();
  var ests = d.estimates || [];
  if (!ests.length) { el.innerHTML = '<div class="card"><div class="empty"><div class="empty-icon">📋</div><p>No estimate yet. Will be sent after the discovery meeting.</p></div></div>'; return; }
  var est = ests[0];
  var items = d.items || [];
  el.innerHTML = '<div class="est-box"><div class="est-hdr"><div><div style="font-weight:700">' + esc(est.title) + '</div><div style="font-size:11px;color:var(--muted)">' + (est.estimate_number || '') + '</div></div>' + badge(est.status) + '</div>'
    + '<table class="est-tbl"><thead><tr><th>Description</th><th>Qty</th><th>Unit</th><th>Price</th><th>Total</th></tr></thead><tbody>'
    + items.map(function(i) { return '<tr><td>' + esc(i.description) + '</td><td>' + i.quantity + '</td><td>' + i.unit + '</td><td>' + i.unit_price + '</td><td><b>' + i.total + '</b></td></tr>'; }).join('')
    + '</tbody></table><div class="est-total"><span>Total</span><span style="color:var(--gl)">' + est.total + ' ' + est.currency + '</span></div></div>'
    + (est.status === 'sent' ? '<div style="display:flex;gap:12px;margin-top:16px"><button class="btn btn-confirm" onclick="respondEstimate(\'' + est.id + '\',\'approved\')">✅ Approve</button><button class="btn btn-reject" onclick="respondEstimate(\'' + est.id + '\',\'rejected\')">❌ Reject</button></div>' : '')
    + (est.notes ? '<div class="card" style="margin-top:12px"><div style="font-size:12px;color:var(--muted)"><b>Notes:</b> ' + esc(est.notes) + '</div></div>' : '');
}

async function respondEstimate(estId, action) {
  var notes = action === 'rejected' ? (prompt('Reason (optional):') || '') : '';
  var r = await api('PUT', '/proj/estimates/' + estId + '/respond', { action: action, client_notes: notes });
  if (r.ok) { toast(action === 'approved' ? '✅ Estimate approved!' : 'Estimate rejected'); loadEstimate(_currentProject && _currentProject.project && _currentProject.project.id); }
}

// ── Invoices ──────────────────────────────────────────────────────────────────
async function loadInvoices(projectId) {
  var el = document.getElementById('pt-invoices-content');
  if (!el) return;
  el.innerHTML = '<div class="empty"><div class="empty-icon">⏳</div>Loading...</div>';
  var r = await api('GET', '/proj/projects/' + projectId + '/invoices');
  var d = await r.json();
  var invs = d.invoices || [];
  if (!invs.length) { el.innerHTML = '<div class="card"><div class="empty"><div class="empty-icon">🧾</div><p>No invoices yet.</p></div></div>'; return; }
  el.innerHTML = invs.map(function(inv) {
    var isPaid = inv.status === 'paid';
    var canPay = ['sent', 'pending', 'invoiced'].includes(inv.status) && parseFloat(inv.total || 0) > 0;
    var items = Array.isArray(inv.line_items) ? inv.line_items : [];
    return '<div class="card" style="margin-bottom:14px">'
      + '<div style="display:flex;justify-content:space-between;align-items:flex-start;margin-bottom:14px"><div><div style="font-size:10px;font-weight:700;font-family:monospace;color:var(--gl)">' + (inv.invoice_number || '—') + '</div><div style="font-size:16px;font-weight:800">' + esc(inv.title) + '</div>' + (inv.due_date ? '<div style="font-size:12px;color:var(--warn)">Due: ' + inv.due_date + '</div>' : '') + '</div>' + badge(inv.status) + '</div>'
      + (items.length ? '<table style="width:100%;border-collapse:collapse;margin-bottom:12px;font-size:12px"><thead><tr style="background:var(--bg3)"><th style="padding:7px;text-align:left">Description</th><th style="padding:7px;text-align:right">Qty</th><th style="padding:7px;text-align:right">Price</th><th style="padding:7px;text-align:right">Total</th></tr></thead><tbody>' + items.map(function(i) { return '<tr style="border-bottom:1px solid var(--border)"><td style="padding:7px">' + esc(i.description) + '</td><td style="padding:7px;text-align:right">' + i.quantity + '</td><td style="padding:7px;text-align:right">$' + parseFloat(i.unit_price || 0).toFixed(2) + '</td><td style="padding:7px;text-align:right;font-weight:700">$' + parseFloat(i.total || 0).toFixed(2) + '</td></tr>'; }).join('') + '</tbody></table>' : '')
      + '<div style="display:flex;justify-content:space-between;align-items:center;padding:10px;background:var(--bg3);border-radius:8px;margin-bottom:14px"><span>Total</span><span style="font-size:20px;font-weight:800;color:' + (isPaid ? 'var(--gl)' : 'var(--text)') + '">$' + parseFloat(inv.total || 0).toFixed(2) + ' ' + (inv.currency || 'USD') + '</span></div>'
      + (isPaid ? '<div style="background:rgba(15,181,116,.08);border:1px solid rgba(15,181,116,.2);border-radius:7px;padding:10px 14px;font-size:12px;color:var(--gl)">✅ Paid on ' + fmtDate(inv.paid_at) + '</div>' : '')
      + (canPay ? '<button class="btn btn-primary" onclick="payInvoice(\'' + inv.id + '\')"><span class="spinner" id="invpay-' + inv.id + '" style="display:none"></span>💳 Pay Now — $' + parseFloat(inv.total).toFixed(2) + ' ' + (inv.currency || 'USD') + '</button>' : '')
      + '</div>';
  }).join('');
}

async function payInvoice(invId) {
  var spin = document.getElementById('invpay-' + invId);
  if (spin) spin.style.display = 'inline-block';
  var r = await api('POST', '/proj/invoices/' + invId + '/create-payment', {});
  var d = await r.json();
  if (spin) spin.style.display = 'none';
  if (r.ok && d.checkout_url) location.href = d.checkout_url;
  else toast('❌ ' + (d.error || 'Payment failed'), 'err');
}

// ── Files ─────────────────────────────────────────────────────────────────────
function _fmtBytes(b) { if(!b) return ''; return b<1048576?(b/1024).toFixed(1)+' KB':(b/1048576).toFixed(2)+' MB'; }
function _extBadge(name) {
  var ext=(name||'').split('.').pop().toUpperCase().slice(0,5)||'FILE';
  var clr={'PDF':'#ef4444','DOC':'#3b82f6','DOCX':'#3b82f6','XLS':'#22c55e','XLSX':'#22c55e',
            'PNG':'#a855f7','JPG':'#a855f7','JPEG':'#a855f7','ZIP':'#f59e0b','CSV':'#22c55e'}[ext]||'#6b7280';
  return '<div style="width:32px;height:32px;background:'+clr+'18;color:'+clr+';border-radius:6px;display:flex;align-items:center;justify-content:center;font-size:9px;font-weight:800;flex-shrink:0">'+ext+'</div>';
}

function renderFiles(files) {
  var el = document.getElementById('pt-files-list');
  if (!el) return;
  if (!files || !files.length) { el.innerHTML = '<div class="empty"><div class="empty-icon">📎</div><p>No files yet. Upload the first file!</p></div>'; return; }

  // Group by folder
  var groups = {};
  files.forEach(function(f) {
    var k = f.folder || 'General';
    if (!groups[k]) groups[k] = [];
    groups[k].push(f);
  });

  var html = '';
  Object.keys(groups).sort(function(a,b){ return a==='General'?-1:b==='General'?1:a.localeCompare(b); }).forEach(function(folder) {
    html += '<div style="margin-bottom:14px">'
      + '<div style="display:flex;align-items:center;gap:6px;font-size:11px;font-weight:800;text-transform:uppercase;color:var(--muted);letter-spacing:.06em;margin-bottom:8px">📁 '+esc(folder)+' <span style="font-weight:400">('+groups[folder].length+')</span></div>'
      + groups[folder].map(function(f) {
          return '<div class="meeting-item" style="padding:10px 14px;margin-bottom:6px;gap:10px">'
            +_extBadge(f.filename)
            +'<div style="flex:1;min-width:0">'
            +  '<div style="font-weight:600;font-size:13px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap">'+esc(f.filename||'file')+'</div>'
            +  '<div style="font-size:11px;color:var(--muted);margin-top:2px">'
            +    (f.uploaded_by_name?esc(f.uploaded_by_name)+' · ':'')
            +    (_fmtBytes(f.file_size)?_fmtBytes(f.file_size)+' · ':'')
            +    fmtDate(f.created_at)
            +  '</div>'
            +'</div>'
            +'<a href="'+f.file_url+'" download="'+esc(f.filename||'file')+'" target="_blank" class="btn btn-outline btn-sm">⬇</a>'
            +'<button onclick="deleteClientFile(\''+f.id+'\',\''+esc(f.filename||'file')+'\')" class="btn btn-danger btn-sm" style="margin-left:6px;padding:4px 8px" title="Delete file">🗑</button>'
            +'</div>';
        }).join('')
      +'</div>';
  });
  el.innerHTML = html;
}

async function uploadFile(input) {
  if (!input.files[0]) return;
  var pid = _currentProject && _currentProject.project && _currentProject.project.id;
  if (!pid) return;
  var file = input.files[0];
  var lbl = input.closest('label');
  if (lbl) { lbl.innerHTML = '⏳ Uploading...'; lbl.style.pointerEvents = 'none'; }
  try {
    var r1 = await api('POST', '/proj/projects/' + pid + '/files/upload-url', { filename: file.name, file_type: file.type });
    var d1 = await r1.json();
    if (!r1.ok) throw new Error(d1.error);
    await fetch(d1.signed_url, { method: 'PUT', headers: { 'Content-Type': file.type }, body: file });
    var folder = (document.getElementById('files-folder-input')||{}).value || '';
    var r2 = await api('POST', '/proj/projects/' + pid + '/files', { filename: file.name, file_path: d1.path, file_size: file.size, file_type: file.type, folder: folder.trim() || null });
    var d2 = await r2.json();
    if (!r2.ok) throw new Error(d2.error);
    toast('✅ ' + file.name + ' uploaded');
    var r3 = await api('GET', '/proj/projects/' + pid + '/files');
    var d3 = await r3.json();
    toast('File uploaded ✅', 'ok');
    await refreshProjectTab('files');
  } catch(e) {
    toast('❌ ' + e.message, 'err');
  } finally {
    if (lbl) { lbl.innerHTML = '📎 Upload <input type="file" style="display:none" onchange="uploadFile(this)">'; lbl.style.pointerEvents = ''; }
    input.value = '';
  }
}

async function deleteClientFile(fileId, filename) {
  if (!confirm('Delete "' + filename + '"? This cannot be undone.')) return;
  try {
    var r = await api('DELETE', '/proj/files/' + fileId);
    var d = await r.json().catch(function(){ return {}; });
    if (r.ok) {
      toast('🗑 File deleted', 'ok');
      await refreshProjectTab('files');
    } else {
      toast('❌ ' + (d.error || 'Delete failed'), 'err');
    }
  } catch(e) {
    toast('❌ ' + e.message, 'err');
  }
}

// ── ERP Connections ───────────────────────────────────────────────────────────
var _connCache = {};

async function loadConnections(projectId) {
  var el = document.getElementById('pt-connections-list');
  if (!el) return;
  el.innerHTML = '<div class="empty"><p>Loading&#8230;</p></div>';

  var r = await api('GET', '/proj/projects/' + projectId + '/connections');
  var d = await r.json().catch(function(){ return {}; });
  var conns = (d.connections || []).filter(function(c){ return c.is_active !== false; });

  // Cache for edit
  _connCache = {};
  conns.forEach(function(c){ if (c.id) _connCache[c.id] = c; });

  // Security banner
  var banner = '<div style="display:flex;align-items:center;gap:10px;background:rgba(245,158,11,.06);border:1px solid rgba(245,158,11,.2);border-radius:10px;padding:12px 16px;margin-bottom:14px">'
    + '<span style="font-size:18px">&#128274;</span>'
    + '<div><div style="font-size:12px;font-weight:700;color:var(--warn)">ERP Credentials &#8212; Confidential</div>'
    + '<div style="font-size:11px;color:var(--muted)">All fields hidden by default. Click Show to reveal.</div></div></div>';

  if (!conns.length) {
    el.innerHTML = banner + '<div class="empty"><div class="empty-icon">&#128268;</div><p>No ERP connections yet. Use &#8220;+ Add Connection&#8221; above.</p></div>';
    return;
  }

  // Build rows via DOM
  el.innerHTML = banner;
  conns.forEach(function(c, idx) {
    var hasVpn = !!(c.vpn_server || c.vpn_type);

    var card = document.createElement('div');
    card.style.cssText = 'background:var(--bg2);border:1px solid var(--border);border-radius:12px;padding:16px;margin-bottom:14px';

    // Header row
    var hdr = document.createElement('div');
    hdr.style.cssText = 'display:flex;justify-content:space-between;align-items:center;margin-bottom:14px';

    var titleDiv = document.createElement('div');
    titleDiv.style.cssText = 'font-weight:800;font-size:14px';
    titleDiv.textContent = '&#128268; ' + (c.erp_system || 'ERP') + ' &#8212; ' + (c.environment || '');
    titleDiv.innerHTML = '&#128268; ' + esc(c.erp_system || 'ERP') + ' &#8212; ' + esc(c.environment || '');

    var btns = document.createElement('div');
    btns.style.cssText = 'display:flex;gap:8px;align-items:center';

    var editBtn = document.createElement('button');
    editBtn.className = 'btn btn-outline btn-sm';
    editBtn.style.fontSize = '11px';
    editBtn.textContent = '&#9998; Edit';
    editBtn.addEventListener('click', function(){ openEditConnForm(projectId, c.id); });

    var delBtn = document.createElement('button');
    delBtn.style.cssText = 'background:rgba(224,82,82,.1);border:1px solid rgba(224,82,82,.25);color:var(--danger);border-radius:6px;padding:4px 10px;font-size:11px;cursor:pointer;font-family:inherit';
    delBtn.innerHTML = '&#128465; Delete';
    delBtn.addEventListener('click', function(){ deleteConnection(projectId, c.id, c.erp_system, card); });

    btns.appendChild(editBtn);
    btns.appendChild(delBtn);
    hdr.appendChild(titleDiv);
    hdr.appendChild(btns);
    card.appendChild(hdr);

    // Masked fields
    function mkMasked(label, val, fid) {
      if (!val) return null;
      var wrap = document.createElement('div');
      wrap.style.cssText = 'padding:6px 0;border-bottom:1px solid var(--border)';
      var lbl = document.createElement('div');
      lbl.style.cssText = 'font-size:10px;color:var(--muted);font-weight:700;text-transform:uppercase;margin-bottom:4px';
      lbl.textContent = label;
      var row = document.createElement('div');
      row.style.cssText = 'display:flex;align-items:center;gap:6px';
      var inp = document.createElement('input');
      inp.type='password'; inp.id=fid; inp.value=String(val); inp.readOnly=true;
      inp.style.cssText = 'font-family:monospace;font-size:12px;background:var(--bg2);border:1px solid var(--border);border-radius:6px;padding:5px 10px;color:var(--text);flex:1;min-width:0';
      var showB = document.createElement('button');
      showB.textContent='Show';
      showB.style.cssText='background:var(--bg3);border:1px solid var(--border);border-radius:5px;padding:4px 10px;cursor:pointer;font-size:11px;color:var(--muted)';
      showB.addEventListener('click', function(){ var s=inp.type==='text'; inp.type=s?'password':'text'; showB.textContent=s?'Show':'Hide'; });
      var copyB = document.createElement('button');
      copyB.textContent='Copy';
      copyB.style.cssText='background:var(--bg3);border:1px solid var(--border);border-radius:5px;padding:4px 10px;cursor:pointer;font-size:11px;color:var(--muted)';
      copyB.addEventListener('click', function(){ navigator.clipboard.writeText(inp.value); toast('Copied','success'); });
      row.appendChild(inp); row.appendChild(showB); row.appendChild(copyB);
      wrap.appendChild(lbl); wrap.appendChild(row);
      return wrap;
    }

    // ERP fields
    var erpWrap = document.createElement('div');
    erpWrap.style.cssText = 'background:var(--bg3);border-radius:8px;padding:12px' + (hasVpn ? ';margin-bottom:8px' : '');
    var erpHdr = document.createElement('div');
    erpHdr.style.cssText = 'font-size:10px;font-weight:700;color:var(--muted);text-transform:uppercase;margin-bottom:8px';
    erpHdr.textContent = 'ERP System Access';
    erpWrap.appendChild(erpHdr);
    var erpGrid = document.createElement('div');
    erpGrid.style.cssText = 'display:grid;grid-template-columns:1fr 1fr;gap:8px';
    [['Server URL',c.server_url,'srv-'+idx],['Client / Sys No.',c.client_number,'cln-'+idx],
     ['System ID',c.system_id,'sid-'+idx],['Username',c.username,'usr-'+idx],['Password',c.password,'pw-'+idx]
    ].forEach(function(f){ var m=mkMasked(f[0],f[1],f[2]); if(m) erpGrid.appendChild(m); });
    erpWrap.appendChild(erpGrid);
    card.appendChild(erpWrap);

    // VPN fields
    if (hasVpn) {
      var vpnWrap = document.createElement('div');
      vpnWrap.style.cssText = 'background:rgba(59,130,246,.05);border:1px solid rgba(59,130,246,.15);border-radius:8px;padding:12px';
      var vpnHdr = document.createElement('div');
      vpnHdr.style.cssText = 'font-size:10px;font-weight:700;color:#60a5fa;text-transform:uppercase;margin-bottom:8px';
      vpnHdr.textContent = 'VPN Access';
      vpnWrap.appendChild(vpnHdr);
      var vpnGrid = document.createElement('div');
      vpnGrid.style.cssText = 'display:grid;grid-template-columns:1fr 1fr;gap:8px';
      [['VPN Type',c.vpn_type,'vt-'+idx],['VPN Server',c.vpn_server,'vs-'+idx],
       ['VPN Username',c.vpn_username,'vu-'+idx],['VPN Password',c.vpn_password,'vp-'+idx]
      ].forEach(function(f){ var m=mkMasked(f[0],f[1],f[2]); if(m) vpnGrid.appendChild(m); });
      vpnWrap.appendChild(vpnGrid);
      card.appendChild(vpnWrap);
    }

    if (c.notes) {
      var notesEl = document.createElement('div');
      notesEl.style.cssText = 'margin-top:8px;font-size:12px;color:var(--muted);padding:8px 12px;background:var(--bg3);border-radius:6px';
      notesEl.textContent = c.notes;
      card.appendChild(notesEl);
    }

    el.appendChild(card);
  });
}

function openEditConnForm(projectId, connId) {
  var c = _connCache[connId];
  if (!c) { toast('Could not load connection data', 'error'); return; }
  // Populate form
  var setV = function(id, v){ var el=document.getElementById(id); if(el) el.value=v||''; };
  setV('c-erp', c.erp_system); setV('c-env', c.environment);
  setV('c-url', c.server_url); setV('c-user', c.username);
  setV('c-pass', ''); // don't pre-fill password
  setV('c-client', c.client_number); setV('c-vpn-type', c.vpn_type);
  setV('c-vpn-server', c.vpn_server); setV('c-vpn-user', c.vpn_username);
  setV('c-vpn-pass', ''); setV('c-notes', c.notes);
  // Mark form as edit mode
  var form = document.getElementById('conn-form');
  if (form) { form.dataset.editId = connId; form.style.display = 'block'; form.scrollIntoView({behavior:'smooth'}); }
  // Update submit button text
  var btn = document.getElementById('conn-submit-btn');
  if (btn) btn.textContent = '&#128190; Update Connection';
}

async function deleteConnection(projectId, connId, name, cardEl) {
  if (!confirm('Delete "' + (name || 'this connection') + '"? It will be moved to trash and admins can restore it.')) return;
  var r = await api('DELETE', '/proj/projects/' + projectId + '/connections/' + connId);
  var d = await r.json().catch(function(){ return {}; });
  if (r.ok) {
    toast('Connection deleted', 'success');
    if (cardEl) { cardEl.style.opacity='0'; cardEl.style.transition='opacity .3s'; setTimeout(function(){ cardEl.remove(); }, 300); }
  } else {
    toast('Error: ' + (d.error || 'Failed to delete'), 'error');
  }
}

async function submitConnection() {
  var msg = document.getElementById('conn-msg');
  var pid = _currentProject && _currentProject.project && _currentProject.project.id;
  var form  = document.getElementById('conn-form');
  var editId = form && form.dataset.editId;
  var method = editId ? 'PUT' : 'POST';
  var url    = '/proj/projects/' + pid + '/connections' + (editId ? '/' + editId : '');
  var r = await api(method, url, {
    erp_system: (document.getElementById('c-erp') || {}).value || '',
    environment: (document.getElementById('c-env') || {}).value || '',
    server_url:  (document.getElementById('c-url') || {}).value || '',
    username:    (document.getElementById('c-user') || {}).value || '',
    password:    (document.getElementById('c-pass') || {}).value || '',
    client_number: (document.getElementById('c-client') || {}).value || '',
    vpn_type:    (document.getElementById('c-vpn-type') || {}).value || '',
    vpn_server:  (document.getElementById('c-vpn-server') || {}).value || '',
    vpn_username:(document.getElementById('c-vpn-user') || {}).value || '',
    vpn_password:(document.getElementById('c-vpn-pass') || {}).value || '',
    notes:       (document.getElementById('c-notes') || {}).value || '',
  });
  var d = await r.json();
  if (r.ok) { if (msg) msg.innerHTML = '<div class="ok-msg">✅ Connection saved</div>'; loadConnections(pid); document.getElementById('conn-form').style.display = 'none'; }
  else { if (msg) msg.innerHTML = '<div class="err-msg">❌ ' + esc(d.error || 'Failed') + '</div>'; }
}

// ── Chat ──────────────────────────────────────────────────────────────────────
function loadChat(projectId) {
  var el = document.getElementById('chat-container');
  if (!el) return;
  // Ensure escHtml is available (alias to esc)
  if (typeof escHtml === 'undefined') { window.escHtml = function(s){ return esc(s); }; }
  if (_chatTimer) { clearInterval(_chatTimer); _chatTimer = null; }

  // Get EOH team members from current project data
  var d = _currentProject || {};
  var team = d.eoh_team || [];
  console.log('[Chat] eoh_team:', team.length, 'members', JSON.stringify(team.slice(0,2)));

  _chatState = {
    projectId: projectId,
    messages: [], lastTs: null, replyTo: null,
    myId: USER && USER.id,
    myName: USER && USER.full_name,
    activeConvo: '_all',
    team: team,
  };

  // ── Build the full chat layout ────────────────────────────────────────────
  el.style.cssText = 'display:flex;height:100%;overflow:hidden;border-radius:14px;border:1px solid var(--border);box-shadow:0 4px 24px rgba(0,0,0,.18)';
  el.innerHTML = '';

  // ── Sidebar ───────────────────────────────────────────────────────────────
  var sidebar = document.createElement('div');
  sidebar.id = 'chat-sidebar';
  sidebar.className = 'chat-sidebar';

  // Save original sidebar before replacing
  if (!window._originalSidebarHTML) {
    window._originalSidebarHTML = sidebar.innerHTML;
  }

  var proj  = (_currentProject && _currentProject.project) || {};
  var projSub = proj.erp_system ? '⚙️ ' + esc(proj.erp_system) : '';
  var myAv  = (USER && USER.full_name ? USER.full_name.charAt(0) : 'C').toUpperCase();

  sidebar.style.cssText = 'width:220px;flex-shrink:0;border-right:1px solid var(--border);background:var(--bg3);display:flex;flex-direction:column;overflow:hidden';
  sidebar.innerHTML =
    '<div style="padding:14px 14px 10px;border-bottom:1px solid var(--border);background:var(--bg2)"><div style="font-size:13px;font-weight:800;color:var(--text);margin-bottom:2px">&#128172; Project Chat</div><div style="font-size:11px;color:var(--muted)">'+(proj.title||'')+(proj.erp_system?' · '+esc(proj.erp_system):'')+'</div></div>'
    + '<div class="chat-profile-card">'
    +   '<div style="display:flex;align-items:center;gap:10px;margin-bottom:2px">'
    +     '<div class="chat-profile-avatar" style="background:rgba(15,181,116,.15);color:var(--gl)">'+myAv+'</div>'
    +     '<div style="min-width:0;flex:1">'
    +       '<div style="font-weight:700;font-size:13px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap">'+esc(USER&&USER.full_name||'You')+'</div>'
    +       '<div style="font-size:10px;color:var(--gl);font-weight:600;margin-top:2px">Project Client</div>'
    +     '</div>'
    +     '<span style="font-size:9px;font-weight:700;background:rgba(15,181,116,.12);color:var(--gl);border-radius:20px;padding:2px 7px;flex-shrink:0">YOU</span>'
    +   '</div>'
    +   (projSub ? '<div style="font-size:10px;color:var(--muted);margin-top:6px">'+projSub+'</div>' : '')
    + '</div>'
    + (team.length ? '<div style="padding:8px 14px 4px;font-size:10px;font-weight:800;text-transform:uppercase;color:var(--muted);letter-spacing:.08em">EOH Team ('+team.length+')</div>' : '');



  // Members label
  var memLbl = document.createElement('div');
  memLbl.style.cssText = 'padding:10px 14px 4px;font-size:10px;font-weight:800;text-transform:uppercase;letter-spacing:.08em;color:var(--muted)';
  memLbl.textContent = 'Members (' + (team.filter(function(m){ return m.full_name; }).length + 1) + ')';
  sidebar.appendChild(memLbl);

  // Me row
  var meRow = document.createElement('div');
  meRow.style.cssText = 'display:flex;align-items:center;gap:10px;padding:8px 14px;background:rgba(15,181,116,.06);border-left:3px solid var(--gl)';
  meRow.innerHTML = '<div style="width:32px;height:32px;border-radius:50%;background:rgba(129,140,248,.15);color:#818cf8;display:flex;align-items:center;justify-content:center;font-weight:700;font-size:13px;flex-shrink:0">'+myAv+'</div>'
    + '<div style="flex:1;min-width:0"><div style="font-size:12px;font-weight:700;color:var(--text);overflow:hidden;text-overflow:ellipsis;white-space:nowrap">'+esc(USER&&USER.full_name||'You')+'</div>'
    + '<div style="font-size:10px;color:var(--gl)">Client</div></div>'
    + '<span style="font-size:9px;font-weight:700;background:var(--gl);color:#fff;border-radius:4px;padding:1px 5px">YOU</span>';
  sidebar.appendChild(meRow);

  if (!team.filter(function(m){ return m.full_name; }).length) {
    var noTeam = document.createElement('div');
    noTeam.style.cssText = 'padding:18px 14px;font-size:11px;color:var(--muted);text-align:center;line-height:1.6';
    noTeam.textContent = 'No team members assigned yet';
    sidebar.appendChild(noTeam);
  } else {
    team.filter(function(m){ return m.full_name; }).forEach(function(m) {
      var clr = m.role === 'consultant' ? '#60a5fa' : '#f59e0b';
      var lbl = m.role === 'consultant' ? 'Consultant' : 'ERP Manager';
      var av  = m.full_name.charAt(0).toUpperCase();
      var item = document.createElement('div');
      item.setAttribute('data-cid', m.id);
      item.style.cssText = 'display:flex;align-items:center;gap:10px;padding:8px 14px;border-left:3px solid transparent;transition:.15s;cursor:pointer';
      item.innerHTML =
        '<div style="width:32px;height:32px;border-radius:50%;background:'+clr+'22;color:'+clr+';display:flex;align-items:center;justify-content:center;font-weight:700;font-size:13px;flex-shrink:0">'+av+'</div>'
        + '<div style="flex:1;min-width:0"><div style="font-size:12px;font-weight:600;color:var(--text);overflow:hidden;text-overflow:ellipsis;white-space:nowrap">'+esc(m.full_name)+'</div>'
        + '<div style="font-size:10px;color:'+clr+'">'+lbl+'</div></div>'
        + '<div style="width:7px;height:7px;border-radius:50%;background:#22c55e;flex-shrink:0" title="Online"></div>';
      item.onclick = (function(mid){ return function(){ switchConvo(mid); }; })(m.id);
      sidebar.appendChild(item);
    });
  }

  // ── Main panel ────────────────────────────────────────────────────────────
  var panel = document.createElement('div');
  panel.id = 'chat-main';
  panel.style.cssText = 'flex:1;display:flex;flex-direction:column;min-width:0;background:var(--bg2);position:relative';

  var chatHdr = document.createElement('div');
  chatHdr.className = 'chat-header';
  chatHdr.style.cssText = 'display:flex;align-items:center;justify-content:space-between;padding:12px 18px;border-bottom:1px solid var(--border);background:var(--bg3);flex-shrink:0';
  chatHdr.innerHTML =
    '<div style="display:flex;align-items:center;gap:10px">'
    +   '<div style="width:8px;height:8px;border-radius:50%;background:#22c55e;box-shadow:0 0 6px rgba(34,197,94,.5)"></div>'
    +   '<div><div style="font-size:13px;font-weight:700;color:var(--text)">&#128172; Project Chat</div>'
    +   '<div id="chat-status" style="font-size:10px;color:var(--muted)">Connecting...</div></div>'
    + '</div>'
    + '<div style="font-size:11px;color:var(--muted)">'+(proj.title||'')+'</div>';

  var msgsDiv = document.createElement('div');
  msgsDiv.id = 'chat-msgs';
  msgsDiv.className = 'chat-msgs';
  msgsDiv.style.cssText = 'flex:1;overflow-y:auto;padding:16px;display:flex;flex-direction:column;gap:2px;background:var(--bg2)';

  var replyBar = document.createElement('div');
  replyBar.id = 'chat-reply-bar';
  replyBar.style.display = 'none';

  var footer = document.createElement('div');
  footer.className = 'chat-footer';
  footer.style.cssText = 'padding:10px 14px;border-top:1px solid var(--border);background:var(--bg3);flex-shrink:0';
  footer.innerHTML = '<div style="display:flex;align-items:flex-end;gap:8px;background:var(--bg2);border:1px solid var(--border);border-radius:12px;padding:6px 8px 6px 14px">'
    + '<label style="cursor:pointer;color:var(--muted);padding:4px;border-radius:6px;font-size:16px;flex-shrink:0" title="Attach file">&#128206;<input type="file" style="display:none" onchange="chatAttach(this)"></label>'
    + '<button onclick="chatEmoji()" style="background:none;border:none;color:var(--muted);cursor:pointer;padding:4px;font-size:16px;flex-shrink:0" title="Emoji">&#128522;</button>'
    + '<div id="chat-input" class="chat-input" contenteditable="true" data-placeholder="Type a message..." onkeydown="chatKeydown(event)" oninput="chatInputChange()" style="flex:1;min-height:24px;max-height:120px;overflow-y:auto;outline:none;font-size:13px;color:var(--text);line-height:1.5;padding:4px 0"></div>'
    + '<button id="chat-send" onclick="chatSend()" disabled style="background:linear-gradient(135deg,#0fb574,#0A4FCC);border:none;color:#fff;width:34px;height:34px;border-radius:50%;cursor:pointer;font-size:15px;display:flex;align-items:center;justify-content:center;flex-shrink:0;transition:.2s;opacity:.4" title="Send (Enter)">&#10148;</button>'
    + '</div>';

  panel.appendChild(chatHdr);
  panel.appendChild(msgsDiv);
  panel.appendChild(replyBar);
  panel.appendChild(footer);
  el.appendChild(sidebar);
  el.appendChild(panel);

  var style = document.createElement('style');
  style.textContent = '[data-cid].active{background:rgba(15,181,116,.07)!important;border-left-color:var(--gl)!important}';
  el.appendChild(style);

  fetchChatMsgs(true);
  _chatTimer = setInterval(function(){ fetchChatMsgs(false); }, 5000);
}
// Switch conversation filter
function switchConvo(memberId) {
  if (!_chatState) return;
  _chatState.activeConvo = memberId;
  // Update sidebar active state
  document.querySelectorAll('[data-cid]').forEach(function(el) {
    el.classList.remove('convo-active');
    el.style.background = '';
    el.style.borderLeftColor = 'transparent';
    if (el.getAttribute('data-cid') === memberId) {
      el.classList.add('convo-active');
      el.style.background = 'rgba(15,181,116,.08)';
      el.style.borderLeftColor = 'var(--gl)';
    }
  });
  var titleEl = document.getElementById('chat-convo-title');
  if (titleEl) {
    if (memberId === '_all') {
      titleEl.textContent = '&#128172; All Messages';
    } else {
      var member = (_chatState.team||[]).find(function(m){ return m.id === memberId; });
      titleEl.textContent = member ? '&#128172; ' + member.full_name : '&#128172; Conversation';
    }
  }
  renderChatMsgs(_chatState.messages);
}

function destroyChat() {
  if (_chatTimer) { clearInterval(_chatTimer); _chatTimer = null; }
  _chatState = null;
  // Restore original sidebar if it was replaced by chat
  var sidebar = document.getElementById('sidebar');
  if (sidebar && window._originalSidebarHTML) {
    sidebar.innerHTML = window._originalSidebarHTML;
    sidebar.className = '';
    sidebar.style.cssText = '';
    window._originalSidebarHTML = null;
  }
}

async function fetchChatMsgs(initial) {
  if (!_chatState) return;
  try {
    var url = '/proj/projects/' + _chatState.projectId + '/messages';
    if (!initial && _chatState.lastTs) url += '?since=' + encodeURIComponent(_chatState.lastTs);
    var r = await api('GET', url);
    var d = await r.json();
    var msgs = d.messages || [];
    if (initial) { _chatState.messages = msgs; }
    else {
      var ids = new Set(_chatState.messages.map(function(m) { return m.id; }));
      msgs.filter(function(m) { return !ids.has(m.id); }).forEach(function(m) { _chatState.messages.push(m); });
    }
    if (msgs.length) _chatState.lastTs = msgs[msgs.length - 1].created_at;
    renderChatMsgs(initial);
    var st = document.getElementById('chat-status');
    if (st && initial) { st.textContent = 'Online'; st.style.color = 'var(--gl)'; }
  } catch(e) {
    var st = document.getElementById('chat-status');
    if (st) { st.textContent = 'Offline'; st.style.color = 'var(--danger)'; }
  }
}

function renderChatMsgs(scrollDown) {
  var el = document.getElementById('chat-msgs');
  if (!el || !_chatState) return;
  var wasAtBottom = el.scrollHeight - el.scrollTop <= el.clientHeight + 60;
  var msgs = _chatState.messages;
  if (!msgs.length) { el.innerHTML = '<div style="text-align:center;color:var(--muted);font-size:13px;padding:40px;line-height:2">&#128172;<br>No messages yet. Start the conversation!</div>'; return; }
  var html = '';
  var lastDate = null;
  msgs.forEach(function(m, i) {
    var mine = m.sender_id === _chatState.myId;
    var isSystem = m.sender_type === 'admin' && m.is_system;
    var msgDate = new Date(m.created_at).toDateString();
    if (msgDate !== lastDate) {
      lastDate = msgDate;
      var today = new Date().toDateString(), yest = new Date(Date.now()-86400000).toDateString();
      var dl = msgDate===today?'Today':msgDate===yest?'Yesterday':new Date(m.created_at).toLocaleDateString('en-GB',{day:'numeric',month:'short'});
      html += '<div style="text-align:center;font-size:10px;color:var(--muted);margin:10px 0;display:flex;align-items:center;gap:8px"><span style="flex:1;height:1px;background:var(--border)"></span>'+dl+'<span style="flex:1;height:1px;background:var(--border)"></span></div>';
    }
    if (isSystem) { html += '<div style="text-align:center;font-size:11px;color:var(--muted);background:rgba(107,114,128,.08);border:1px solid rgba(107,114,128,.15);border-radius:20px;padding:5px 14px;margin:6px auto;max-width:80%">&#128276; '+esc(m.message)+'</div>'; return; }
    var prev = i>0?msgs[i-1]:null;
    var showSender = !prev||prev.sender_id!==m.sender_id;
    var senderAv = (m.sender_name||'?').charAt(0).toUpperCase();
    var senderClr = m.sender_type==='manager'?'#f59e0b':m.sender_type==='client'?'#818cf8':'#60a5fa';
    var replyHtml = '';
    if (m.reply_to_id) {
      var parent = msgs.find(function(x){return x.id===m.reply_to_id;});
      if (parent) replyHtml='<div style="background:rgba(255,255,255,.04);border-left:3px solid var(--gl);padding:5px 8px;border-radius:0 6px 6px 0;font-size:11px;color:var(--muted);margin-bottom:4px;cursor:pointer" data-pid="'+parent.id+'" onclick="scrollToMsg(this.dataset.pid)">&#8617; '+esc((parent.message||'').substring(0,80))+'</div>';
    }
    var attHtml = '';
    if (m.attachments&&m.attachments.length) {
      attHtml = m.attachments.map(function(a){
        var sz=a.size?(a.size<1048576?(a.size/1024).toFixed(1)+' KB':(a.size/1048576).toFixed(2)+' MB'):'';
        return '<a href="'+a.url+'" download="'+esc(a.name||'file')+'" target="_blank" style="display:flex;align-items:center;gap:8px;background:rgba(15,181,116,.06);border:1px solid rgba(15,181,116,.15);border-radius:7px;padding:7px 10px;margin-top:6px;font-size:12px;text-decoration:none;color:var(--text)">&#128206; <span>'+esc(a.name||'file')+'</span>'+(sz?'<span style="font-size:10px;color:var(--muted)">'+sz+'</span>':'')+'<span style="color:var(--gl);margin-left:auto">&#11015;</span></a>';
      }).join('');
    }
    var timeStr = new Date(m.created_at).toLocaleTimeString([],{hour:'2-digit',minute:'2-digit'});
    var bubbleBg  = mine?'linear-gradient(135deg,rgba(15,181,116,.18),rgba(10,76,204,.15))':'var(--bg3)';
    var bubbleBdr = mine?'rgba(15,181,116,.25)':'var(--border)';
    var radius    = mine?'14px 14px 4px 14px':'14px 14px 14px 4px';
    var dir       = mine?'row-reverse':'row';
    html += '<div id="cm-'+m.id+'" style="display:flex;align-items:flex-end;gap:8px;margin-bottom:4px;flex-direction:'+dir+'">';
    html += !mine&&showSender?'<div style="width:28px;height:28px;border-radius:50%;background:'+senderClr+'22;color:'+senderClr+';display:flex;align-items:center;justify-content:center;font-size:11px;font-weight:700;flex-shrink:0">'+senderAv+'</div>':'<div style="width:28px;flex-shrink:0"></div>';
    html += '<div style="max-width:68%;display:flex;flex-direction:column;align-items:'+(mine?'flex-end':'flex-start')+'">';
    if (showSender&&!mine) html += '<div style="font-size:10px;font-weight:700;color:'+senderClr+';margin-bottom:3px;padding-left:4px">'+esc(m.sender_name||m.sender_type)+'</div>';
    html += replyHtml;
    html += '<div style="background:'+bubbleBg+';border:1px solid '+bubbleBdr+';border-radius:'+radius+';padding:9px 13px;font-size:13px;line-height:1.5;color:var(--text);word-break:break-word">'+esc(m.message)+attHtml+'</div>';
    html += '<div style="display:flex;align-items:center;gap:6px;margin-top:3px;padding:0 4px">';
    html += '<span style="font-size:10px;color:var(--dim)">'+timeStr+'</span>';
    html += '<button data-mid="'+m.id+'" data-msg="'+escAttr(m.message)+'" onclick="chatReply(this.dataset.mid,this.dataset.msg)" style="background:none;border:none;color:var(--dim);cursor:pointer;font-size:11px;padding:2px 4px;border-radius:4px" title="Reply">&#8617;</button>';
    if (mine) html += '<button data-mid="'+m.id+'" onclick="chatDel(this.dataset.mid)" style="background:none;border:none;color:var(--dim);cursor:pointer;font-size:11px;padding:2px 4px;border-radius:4px" title="Delete">&#128465;</button>';
    html += '</div></div></div>';
  });
  el.innerHTML = html;
  if (scrollDown||wasAtBottom) el.scrollTop = el.scrollHeight;
}

function scrollToMsg(id) {
  var el = document.getElementById('cm-' + id);
  if (el) { el.scrollIntoView({ behavior: 'smooth', block: 'center' }); el.style.background = 'rgba(15,181,116,.08)'; setTimeout(function() { el.style.background = ''; }, 1200); }
}

function chatKeydown(e) { if (e.key === 'Enter' && !e.shiftKey) { e.preventDefault(); chatSend(); } }

function chatInputChange() {
  var inp = document.getElementById('chat-input');
  var btn = document.getElementById('chat-send');
  var hasText = inp && inp.innerText.trim().length > 0;
  if (btn) { btn.disabled = !hasText; btn.style.opacity = hasText ? '1' : '0.4'; }
}

function chatReply(msgId, msgText) {
  if (!_chatState) return;
  _chatState.replyTo = msgId;
  var bar = document.getElementById('chat-reply-bar');
  if (bar) {
    bar.style.display = 'flex';
    bar.className = 'chat-reply-bar';
    bar.innerHTML = '<div><span style="font-weight:700;color:var(--gl)">&#8617; Replying to:</span> ' + esc(msgText.substring(0, 100)) + '</div><button onclick="chatCancelReply()" style="background:none;border:none;color:var(--muted);font-size:16px;cursor:pointer">✕</button>';
  }
  var inp = document.getElementById('chat-input');
  if (inp) inp.focus();
}

function chatCancelReply() {
  if (_chatState) _chatState.replyTo = null;
  var bar = document.getElementById('chat-reply-bar');
  if (bar) { bar.style.display = 'none'; bar.innerHTML = ''; }
}

function chatEmoji() {
  var existing = document.getElementById('emoji-picker');
  if (existing) { existing.remove(); return; }
  var emojis = ['👍','✅','❌','🔥','⚠️','📅','💡','🎉','👀','🙏','💪','🚀','😊','🤔','👎','⏳','🔔','📌','🗂️','✍️'];
  var picker = document.createElement('div');
  picker.id = 'emoji-picker';
  picker.style.cssText = 'position:absolute;bottom:calc(100% - 48px);left:12px;background:var(--bg2);border:1px solid var(--border);border-radius:10px;padding:10px;display:flex;flex-wrap:wrap;gap:4px;z-index:200;max-width:220px;box-shadow:0 8px 24px rgba(0,0,0,.3)';
  picker.innerHTML = emojis.map(function(e){ return '<button onclick="insertEmoji(this.dataset.e)" data-e="'+e+'" style="background:none;border:none;font-size:22px;cursor:pointer;border-radius:6px;padding:3px;width:36px;transition:.1s" onmouseover="this.style.background=\'rgba(15,181,116,.12)\'" onmouseout="this.style.background=\'none\'">'+e+'</button>'; }).join('');
  // Close on click outside
  setTimeout(function(){ document.addEventListener('click', function _ec(ev){ if(!ev.target.closest('#emoji-picker')&&!ev.target.closest('.chat-tool-btn')){ picker.remove(); document.removeEventListener('click',_ec); } }); }, 0);
  var footer = document.querySelector('.chat-footer');
  if (footer) { footer.style.position = 'relative'; footer.appendChild(picker); }
  else { var main = document.getElementById('chat-main'); if(main) main.appendChild(picker); }
}

function insertEmoji(e) {
  var inp = document.getElementById('chat-input');
  if (inp) {
    inp.focus();
    var sel = window.getSelection();
    if (sel.rangeCount && inp.contains(sel.getRangeAt(0).commonAncestorContainer)) {
      var range = sel.getRangeAt(0);
      range.deleteContents();
      range.insertNode(document.createTextNode(e));
      range.collapse(false);
      sel.removeAllRanges(); sel.addRange(range);
    } else {
      inp.innerText += e;
    }
    chatInputChange();
  }
  var picker = document.getElementById('emoji-picker');
  if (picker) picker.remove();
}

async function chatSend() {
  if (!_chatState) return;
  var inp = document.getElementById('chat-input');
  var text = inp ? inp.innerText.trim() : '';
  if (!text) return;
  inp.innerText = '';
  inp.disabled = true;
  var btn = document.getElementById('chat-send');
  if (btn) btn.disabled = true;
  var picker = document.getElementById('emoji-picker');
  if (picker) picker.remove();
  try {
    var r = await api('POST', '/proj/projects/' + _chatState.projectId + '/messages', { message: text, reply_to_id: _chatState.replyTo || null });
    if (r.ok) { var d = await r.json(); _chatState.messages.push(d.message); _chatState.lastTs = d.message.created_at; chatCancelReply(); renderChatMsgs(true); }
  } catch(e) {}
  if (inp) { inp.disabled = false; inp.focus(); }
  if (btn) btn.disabled = false;
}

async function chatDel(msgId) {
  if (!confirm('Delete this message?')) return;
  var r = await api('DELETE', '/proj/messages/' + msgId);
  if (r.ok) { if (_chatState) _chatState.messages = _chatState.messages.filter(function(m) { return m.id !== msgId; }); renderChatMsgs(false); }
  else { var d = await r.json(); toast(d.error || 'Cannot delete', 'err'); }
}

async function chatAttach(input) {
  var file = input.files[0];
  if (!file || !_chatState) return;
  var pid = _chatState.projectId;
  try {
    var r1 = await api('POST', '/proj/projects/' + pid + '/files/upload-url', { filename: file.name, file_type: file.type });
    var d1 = await r1.json();
    if (!r1.ok) throw new Error(d1.error);
    await fetch(d1.signed_url, { method: 'PUT', headers: { 'Content-Type': file.type }, body: file });
    var folder = (document.getElementById('files-folder-input')||{}).value || '';
    var r2 = await api('POST', '/proj/projects/' + pid + '/files', { filename: file.name, file_path: d1.path, file_size: file.size, file_type: file.type, folder: folder.trim() || null });
    var d2 = await r2.json();
    var r3 = await api('POST', '/proj/projects/' + pid + '/messages', { message: '📎 Shared a file: ' + file.name, file_url: d2.file && d2.file.file_url, file_name: file.name, file_type: file.type, file_size: file.size });
    var d3 = await r3.json();
    if (r3.ok) { _chatState.messages.push(d3.message); renderChatMsgs(true); }
  } catch(e) { toast('Upload failed: ' + e.message, 'err'); }
  input.value = '';
}

// ── New Project ───────────────────────────────────────────────────────────────
async function createProject() {
  var msg  = document.getElementById('np-msg');
  var btn  = document.getElementById('np-btn');
  var spin = document.getElementById('np-spin');
  var title = ((document.getElementById('np-title') || {}).value || '').trim();
  var erp   = (document.getElementById('np-erp') || {}).value || '';
  if (!title) { msg.innerHTML = '<div class="err-msg">Title required</div>'; return; }
  if (!erp)   { msg.innerHTML = '<div class="err-msg">ERP system required</div>'; return; }
  btn.disabled = true; spin.style.display = 'inline-block';
  msg.innerHTML = '';
  var r = await api('POST', '/proj/projects', {
    title: title, erp_system: erp,
    industry:    (document.getElementById('np-industry') || {}).value || '',
    description: (document.getElementById('np-desc') || {}).value || '',
    start_date:  (document.getElementById('np-start') || {}).value || null,
    end_date:    (document.getElementById('np-end') || {}).value || null,
  });
  var d = await r.json();
  btn.disabled = false; spin.style.display = 'none';
  if (r.ok) {
    msg.innerHTML = '<div class="ok-msg">&#10003; Project created! Redirecting…</div>';
    ['np-title', 'np-desc'].forEach(function(id) { var el = document.getElementById(id); if (el) el.value = ''; });
    await loadProjects();
    loadOverview();
    setTimeout(function() {
      goSection('projects');
      if (d.project && d.project.id) {
        openProject(d.project.id).then(function() {
          showProjectTab('tickets');
          toast('Create a discovery ticket to unlock all project features.', 'ok');
        });
      }
    }, 1000);
  } else {
    msg.innerHTML = '<div class="err-msg">&#10060; ' + esc(d.error || 'Failed to create project') + '</div>';
  }
}

// ── Tickets wizard ────────────────────────────────────────────────────────────
// ── Ticket settings (pay later flag) ─────────────────────────────────────────
async function loadTicketSettings() {
  try {
    var r = await fetch(API + '/proj/settings/ticket');
    var d = await r.json();
    _ticketSettings.allow_pay_later  = d.allow_pay_later  !== false;
    _ticketSettings.ticket_lead_days = typeof d.ticket_lead_days === 'number' ? d.ticket_lead_days : 7;
    _ticketSettings.max_modules      = typeof d.max_modules      === 'number' ? d.max_modules      : 3;
    _ticketSettings.modules_list     = Array.isArray(d.modules_list) ? d.modules_list : [];
    _ticketSettings.ticket_note      = d.ticket_note || '';
  } catch(e) {
    _ticketSettings.allow_pay_later  = true;
    _ticketSettings.ticket_lead_days = 7;
    _ticketSettings.max_modules      = 3;
    _ticketSettings.modules_list     = [];
    _ticketSettings.ticket_note      = '';
  }
  applyPayLaterVisibility();
  _applyModuleField();
}

function applyPayLaterVisibility() {
  var btn = document.getElementById('wiz-paylater-btn');
  if (btn) btn.style.display = _ticketSettings.allow_pay_later ? 'block' : 'none';
}

// Build module field based on settings — dropdown if list provided, else text input
function _applyModuleField() {
  var wrap = document.getElementById('nt-modules-wrap');
  if (!wrap) return;
  var max  = _ticketSettings.max_modules || 3;
  var list = _ticketSettings.modules_list || [];

  if (list.length > 0) {
    // Multi-select checkboxes
    wrap.innerHTML =
      '<label class="flbl">Modules / Areas Affected * <span style="color:var(--muted);font-weight:400">(select up to ' + max + ')</span></label>'
      + '<div id="nt-modules-checks" style="display:flex;flex-wrap:wrap;gap:8px;padding:10px;background:var(--bg3);border:1px solid var(--border2);border-radius:8px">'
      + list.map(function(m) {
          return '<label style="display:flex;align-items:center;gap:5px;font-size:12px;cursor:pointer;white-space:nowrap">'
            + '<input type="checkbox" class="nt-mod-cb" value="' + esc(m) + '" onchange="_onModuleCheck(this)" style="accent-color:var(--gl)">'
            + esc(m) + '</label>';
        }).join('')
      + '</div>'
      + '<div id="nt-modules-count" style="font-size:11px;color:var(--muted);margin-top:3px">0 / ' + max + ' selected</div>';
  } else {
    // Free-text input
    wrap.innerHTML =
      '<label class="flbl">Modules / Areas Affected * <span style="color:var(--muted);font-weight:400">(max ' + max + ', comma-separated)</span></label>'
      + '<input class="finput" id="nt-modules" placeholder="e.g. FI, CO, HCM" oninput="_validateModulesText(this)">'
      + '<div id="nt-modules-count" style="font-size:11px;color:var(--muted);margin-top:3px"></div>';
  }
}

function _onModuleCheck(cb) {
  var max       = _ticketSettings.max_modules || 3;
  var checked   = Array.from(document.querySelectorAll('.nt-mod-cb:checked'));
  var countEl   = document.getElementById('nt-modules-count');
  // Uncheck if over limit
  if (checked.length > max) { cb.checked = false; checked = Array.from(document.querySelectorAll('.nt-mod-cb:checked')); }
  if (countEl) countEl.textContent = checked.length + ' / ' + max + ' selected';
  // Grey out unchecked boxes if at limit
  document.querySelectorAll('.nt-mod-cb').forEach(function(c) {
    c.disabled = !c.checked && checked.length >= max;
    c.parentElement.style.opacity = c.disabled ? '0.4' : '1';
  });
}

function _validateModulesText(inp) {
  var max    = _ticketSettings.max_modules || 3;
  var parts  = inp.value.split(',').map(function(s){ return s.trim(); }).filter(Boolean);
  var countEl= document.getElementById('nt-modules-count');
  if (countEl) countEl.textContent = parts.length + ' / ' + max + ' entered' + (parts.length > max ? ' ⚠️ max is ' + max : '');
  countEl.style.color = parts.length > max ? 'var(--danger)' : 'var(--muted)';
}

function _getSelectedModules() {
  var max = _ticketSettings.max_modules || 3;
  // Checkbox mode
  var checks = document.querySelectorAll('.nt-mod-cb:checked');
  if (checks.length > 0) return Array.from(checks).map(function(c){ return c.value; }).slice(0, max);
  // Text mode
  var inp = document.getElementById('nt-modules');
  if (inp) return inp.value.split(',').map(function(s){ return s.trim(); }).filter(Boolean).slice(0, max);
  return [];
}

function startNewTicket() {
  var sel = document.getElementById('nt-project');
  if (sel) {
    sel.innerHTML = '<option value="">— Select a project —</option>'
      + _projects.map(function(p) { return '<option value="' + p.id + '" data-erp="' + esc(p.erp_system || '') + '">' + esc((p.project_number || '') + (p.project_number ? ' — ' : '') + p.title) + '</option>'; }).join('');
    sel.onchange = function() { var erp = sel.options[sel.selectedIndex] && sel.options[sel.selectedIndex].dataset.erp; if (erp) { var e = document.getElementById('nt-erp'); if (e) e.value = erp; } };
  }
  var ntDate = document.getElementById('nt-date');
  if (ntDate) {
    var leadDays = _ticketSettings.ticket_lead_days || 7;
    var minDate  = new Date();
    minDate.setDate(minDate.getDate() + leadDays);
    ntDate.min   = minDate.toISOString().split('T')[0];
    ntDate.value = '';
  }
  // Show note if configured
  var noteEl = document.getElementById('wiz-ticket-note');
  if (noteEl) {
    var note = _ticketSettings.ticket_note || '';
    if (note) {
      noteEl.innerHTML = '<div style="background:rgba(245,158,11,.08);border:1px solid rgba(245,158,11,.25);border-radius:8px;padding:12px 16px;margin-bottom:14px;display:flex;align-items:flex-start;gap:10px">'
        + '<span style="font-size:16px;flex-shrink:0">📌</span>'
        + '<span style="font-size:13px;color:var(--warn);line-height:1.6">' + esc(note) + '</span>'
        + '</div>';
      noteEl.style.display = 'block';
    } else {
      noteEl.style.display = 'none';
    }
  }
  // Re-apply module field in case settings loaded after first render
  _applyModuleField();
  var wiz = document.getElementById('ticket-wizard');
  var lst = document.getElementById('tickets-list');
  var hdr = document.getElementById('tk-list-hdr');
  if (wiz) wiz.style.display = 'block';
  if (lst) lst.style.display = 'none';
  if (hdr) hdr.style.display = 'none';
  document.getElementById('wiz-msg').innerHTML = '';
  wizGoStep(1);
}

function closeWizard() {
  var wiz = document.getElementById('ticket-wizard');
  var lst = document.getElementById('tickets-list');
  var hdr = document.getElementById('tk-list-hdr');
  if (wiz) wiz.style.display = 'none';
  if (lst) lst.style.display = 'block';
  if (hdr) hdr.style.display = 'flex';
}

function wizGoStep(n) {
  [1, 2, 3, 4].forEach(function(i) {
    var s  = document.getElementById('wiz-s' + i);
    var ws = document.getElementById('ws-' + i);
    var wl = document.getElementById('wl-' + i);
    if (s)  s.style.display = i === n ? 'block' : 'none';
    if (ws) ws.className = 'wiz-step' + (i === n ? ' active' : i < n ? ' done' : '');
    if (wl) wl.className = 'wiz-line' + (i < n ? ' done' : '');
  });
}

function wizSubmit() {
  var msg  = document.getElementById('wiz-msg');
  var projId = (document.getElementById('nt-project') || {}).value || '';
  var erp  = (document.getElementById('nt-erp') || {}).value || '';
  var type = (document.getElementById('nt-type') || {}).value || '';
  var desc = ((document.getElementById('nt-desc') || {}).value || '').trim();
  if (!projId) { msg.innerHTML = '<div class="err-msg">Please select a project to link this ticket to</div>'; return; }
  if (!erp)    { msg.innerHTML = '<div class="err-msg">ERP System required</div>'; return; }
  if (!type)   { msg.innerHTML = '<div class="err-msg">Support Type required</div>'; return; }
  if (!desc)   { msg.innerHTML = '<div class="err-msg">Description required</div>'; return; }
  var prefDate = ((document.getElementById('nt-date') || {}).value || '').trim();
  var prefTime = ((document.getElementById('nt-time') || {}).value || '').trim();
  if (!prefDate) { msg.innerHTML = '<div class="err-msg">Preferred Meeting Date is required</div>'; return; }
  if (!prefTime) { msg.innerHTML = '<div class="err-msg">Preferred Meeting Time is required</div>'; return; }
  // Validate modules — required, at least 1
  var modules = _getSelectedModules();
  if (!modules.length) { msg.innerHTML = '<div class="err-msg">Please select at least one module</div>'; return; }
  var max = _ticketSettings.max_modules || 3;
  if (modules.length > max) { msg.innerHTML = '<div class="err-msg">Maximum ' + max + ' module' + (max > 1 ? 's' : '') + ' allowed per ticket</div>'; return; }
  var sel = document.getElementById('nt-project');
  var projTxt = sel ? sel.options[sel.selectedIndex].text : '—';
  var rows = [['Project', projTxt], ['ERP System', erp], ['Support Type', type.replace(/_/g, ' ')], ['Priority', (document.getElementById('nt-priority') || {}).value || ''], ['ERP Version', (document.getElementById('nt-version') || {}).value || '—'], ['Modules', modules.join(', ')], ['Date', prefDate], ['Time', prefTime]];
  var rev = document.getElementById('wiz-review');
  if (rev) rev.innerHTML = '<div style="background:var(--bg3);border-radius:8px;padding:16px;margin-bottom:8px">' + rows.map(function(r) { return '<div class="review-row"><span class="lbl">' + r[0] + '</span><span>' + esc(r[1]) + '</span></div>'; }).join('') + '</div><div style="background:var(--bg3);border-radius:8px;padding:14px;font-size:12px;color:var(--muted);line-height:1.6;border-left:3px solid var(--gl)"><b style="color:var(--text);display:block;margin-bottom:4px">Description</b>' + esc(desc) + '</div>';
  wizGoStep(2);
}

async function wizSubmitFinal() {
  var btn  = document.getElementById('wiz-submit-btn2');
  var spin = document.getElementById('wiz-spin2');
  if (btn) btn.disabled = true;
  if (spin) spin.style.display = 'inline-block';
  try {
    var modules = _getSelectedModules();
    var tz = (function() { try { return Intl.DateTimeFormat().resolvedOptions().timeZone; } catch(e) { return 'UTC'; } })();
    var r = await api('POST', '/proj/tickets/submit', {
      project_id:         (document.getElementById('nt-project') || {}).value || null,
      erp_system:         (document.getElementById('nt-erp') || {}).value || '',
      erp_version:        ((document.getElementById('nt-version') || {}).value || '').trim(),
      support_type:       (document.getElementById('nt-type') || {}).value || '',
      priority:           (document.getElementById('nt-priority') || {}).value || 'medium',
      modules:            modules,
      description:        ((document.getElementById('nt-desc') || {}).value || '').trim(),
      preferred_date:     (document.getElementById('nt-date') || {}).value || null,
      preferred_time:     (document.getElementById('nt-time') || {}).value || null,
      preferred_timezone: tz,
      customer_notes:     ((document.getElementById('nt-notes') || {}).value || '').trim(),
    });
    var d = await r.json();
    if (r.ok && d.ok) {
      _wizTicket = d.ticket;
      var tnum = document.getElementById('wiz-ticket-num');
      if (tnum) tnum.textContent = d.ticket && d.ticket.ticket_number ? d.ticket.ticket_number : '';
      var payCont = document.getElementById('wiz-pay-content');
      if (payCont && d.ticket) payCont.innerHTML = '<div style="background:var(--bg3);border-radius:8px;padding:14px;font-size:13px;margin-bottom:12px"><span style="color:var(--muted)">Discovery Fee: </span><b>' + (d.ticket.currency || 'USD') + ' ' + (d.ticket.discovery_fee || '0') + '</b></div>';
      var later = document.getElementById('wiz-paylater-btn');
      if (later) later.style.display = _ticketSettings.allow_pay_later ? 'block' : 'none';
      applyPayLaterVisibility();
      wizGoStep(3);
    } else {
      var msg = document.getElementById('wiz-msg');
      if (msg) msg.innerHTML = '<div class="err-msg">❌ ' + esc(d.error || 'Submission failed') + '</div>';
      wizGoStep(1);
    }
  } catch(e) {
    var msg = document.getElementById('wiz-msg');
    if (msg) msg.innerHTML = '<div class="err-msg">❌ ' + esc(e.message) + '</div>';
    wizGoStep(1);
  } finally {
    if (btn) btn.disabled = false;
    if (spin) spin.style.display = 'none';
  }
}

async function wizPay() {
  if (!_wizTicket) return;
  var btn  = document.getElementById('wiz-pay-btn');
  var spin = document.getElementById('wiz-pay-spin');
  var msg  = document.getElementById('wiz-pay-msg');
  if (btn) btn.disabled = true;
  if (spin) spin.style.display = 'inline-block';
  var r = await api('POST', '/proj/tickets/create-payment', { ticket_id: _wizTicket.id });
  var d = await r.json();
  if (btn) btn.disabled = false;
  if (spin) spin.style.display = 'none';
  if (r.ok && d.checkout_url) location.href = d.checkout_url;
  else if (msg) msg.innerHTML = '<div class="err-msg">❌ ' + esc(d.error || 'Payment failed') + '</div>';
}

async function wizPayLater() {
  if (_wizTicket) await api('POST', '/proj/tickets/pay-later', { ticket_id: _wizTicket.id }).catch(function() {});
  var dm = document.getElementById('wiz-done-msg');
  if (dm) dm.innerHTML = 'Ticket <b>' + esc((_wizTicket && _wizTicket.ticket_number) || '') + '</b> submitted. Pay the discovery fee from My Tickets when ready.';
  wizGoStep(4);
}

// ── Ticket list ───────────────────────────────────────────────────────────────
async function loadTickets() {
  closeWizard();
  var el     = document.getElementById('tickets-list');
  var countEl = document.getElementById('tk-count');
  if (el) el.innerHTML = '<div class="empty"><div class="empty-icon">⏳</div>Loading...</div>';
  var r = await api('GET', '/proj/tickets');
  var d = await r.json();
  var tickets = d.tickets || [];
  window._allTickets = tickets;

  // Populate ERP filter from actual data
  var erpSel = document.getElementById('tkf-erp');
  if (erpSel) {
    var erps = [...new Set(tickets.map(function(t){ return t.erp_system; }).filter(Boolean))].sort();
    erpSel.innerHTML = '<option value="">All ERP Systems</option>'
      + erps.map(function(e){ return '<option value="'+esc(e)+'">'+esc(e)+'</option>'; }).join('');
  }

  applyTicketFilters();
}

function applyTicketFilters() {
  var tickets = window._allTickets || [];
  var status   = (document.getElementById('tkf-status')   || {}).value || '';
  var erp      = (document.getElementById('tkf-erp')      || {}).value || '';
  var type     = (document.getElementById('tkf-type')     || {}).value || '';
  var priority = (document.getElementById('tkf-priority') || {}).value || '';
  var sort     = (document.getElementById('tkf-sort')     || {}).value || 'desc';

  var filtered = tickets.filter(function(t) {
    if (status   && t.status        !== status)   return false;
    if (erp      && t.erp_system    !== erp)      return false;
    if (type     && t.support_type  !== type)     return false;
    if (priority && t.priority      !== priority) return false;
    return true;
  });

  filtered.sort(function(a, b) {
    var da = new Date(a.created_at||'').getTime();
    var db = new Date(b.created_at||'').getTime();
    return sort === 'asc' ? da - db : db - da;
  });

  var el = document.getElementById('tickets-list');
  var countEl = document.getElementById('tk-count');
  if (countEl) countEl.textContent = filtered.length + ' of ' + tickets.length + ' ticket' + (tickets.length !== 1 ? 's' : '');
  if (!el) return;
  if (!filtered.length) {
    el.innerHTML = '<div class="empty" style="padding:40px;text-align:center"><div style="font-size:36px;margin-bottom:10px">🔍</div><div style="color:var(--muted)">No tickets match your filters</div></div>';
    return;
  }
  el.innerHTML = filtered.map(renderTkCard).join('');
}

function clearTicketFilters() {
  ['tkf-status','tkf-erp','tkf-type','tkf-priority'].forEach(function(id) {
    var el = document.getElementById(id); if (el) el.value = '';
  });
  var sortEl = document.getElementById('tkf-sort'); if (sortEl) sortEl.value = 'desc';
  applyTicketFilters();
}

function renderTkCard(t) {
  var isPaid = t.payment_status === 'paid';
  var meetHtml = '';
  if (['confirmed', 'rescheduled'].includes(t.status) && t.meeting_link) {
    var md   = t.confirmed_date || t.preferred_date;
    var mt   = (t.confirmed_time || t.preferred_time || '').replace(/:\d{2}$/, '');
    var mtFmt = mt ? _clFmtTime(mt, t.preferred_timezone || null) : 'TBC';
    var cd = tkCountdown(md, mt);
    _tkCountdowns[t.id] = { date: md, time: mt };
    var locked = !cd.canJoin;
    meetHtml = '<div class="meet-box"><div style="font-size:13px;font-weight:700;color:var(--gl);margin-bottom:10px">📅 Your Meeting is Confirmed</div>'
      + (md ? '<div style="display:flex;gap:8px;flex-wrap:wrap;align-items:center;margin-bottom:10px">'
        + '<span style="display:inline-flex;align-items:center;gap:5px;background:rgba(15,181,116,.1);border:1px solid rgba(15,181,116,.25);color:var(--gl);font-size:13px;font-weight:800;padding:5px 12px;border-radius:8px">📅 ' + md + '</span>'
        + '<span style="display:inline-flex;align-items:center;gap:5px;background:rgba(10,76,204,.15);border:1px solid rgba(10,76,204,.35);color:#60a5fa;font-size:13px;font-weight:800;padding:5px 12px;border-radius:8px">🕐 ' + mtFmt + '</span>'
        + '</div>' : '')
      + ''
      + '<div id="tkcd-' + t.id + '" style="display:inline-flex;align-items:center;background:var(--bg3);border:1px solid var(--border2);border-radius:8px;padding:8px 14px;font-size:13px;font-weight:700;color:' + (cd.canJoin ? 'var(--gl)' : 'var(--warn)') + '">' + cd.display + '</div><br>'
      + (function(){var _p=t.confirmed_platform||t.meeting_platform||'jitsi',_ext=(_p==='meet'||_p==='zoom');var _u=_ext?t.meeting_link:'/pages/eoh-meeting-room?'+new URLSearchParams({platform:_p,link:t.meeting_link,name:(window.USER&&window.USER.full_name)||'Client',company:t.company_name||'',ticket:t.ticket_number||'',erp:t.erp_system||''}).toString();return '<a href="'+_u+'" '+(_ext?'target="_blank"':'')+ ' class="join-btn" style="'+( locked ?'opacity:.3;pointer-events:none':'')+'">⚡ EOH Meeting →</a>';})()
      + (locked ? '<div style="font-size:11px;color:var(--muted);margin-top:8px">🔒 Unlocks 15 minutes before the meeting</div>' : '')
      + '</div>';
  } else if (t.meeting_link) {
    // Has a meeting link but status not yet updated — show confirmed box with available info
    var md2  = t.confirmed_date || t.preferred_date;
    var mt2  = (t.confirmed_time || t.preferred_time || '').replace(/:\d{2}$/, '');
    var mtFmt2 = mt2 ? _clFmtTime(mt2, t.preferred_timezone || null) : 'TBC';
    var cd2 = tkCountdown(md2, mt2);
    _tkCountdowns[t.id] = { date: md2, time: mt2 };
    var locked2 = !cd2.canJoin;
    meetHtml = '<div class="meet-box"><div style="font-size:13px;font-weight:700;color:var(--gl);margin-bottom:10px">📅 Your Meeting is Confirmed</div>'
      + (md2 ? '<div style="display:flex;gap:8px;flex-wrap:wrap;align-items:center;margin-bottom:10px">'
        + '<span style="display:inline-flex;align-items:center;gap:5px;background:rgba(15,181,116,.1);border:1px solid rgba(15,181,116,.25);color:var(--gl);font-size:13px;font-weight:800;padding:5px 12px;border-radius:8px">📅 ' + md2 + '</span>'
        + '<span style="display:inline-flex;align-items:center;gap:5px;background:rgba(10,76,204,.15);border:1px solid rgba(10,76,204,.35);color:#60a5fa;font-size:13px;font-weight:800;padding:5px 12px;border-radius:8px">🕐 ' + mtFmt2 + '</span>'
        + '</div>' : '')
      + ''
      + '<div id="tkcd-' + t.id + '" style="display:inline-flex;align-items:center;background:var(--bg3);border:1px solid var(--border2);border-radius:8px;padding:8px 14px;font-size:13px;font-weight:700;color:' + (cd2.canJoin ? 'var(--gl)' : 'var(--warn)') + '">' + cd2.display + '</div><br>'
      + (function(){var _p=t.confirmed_platform||t.meeting_platform||'jitsi',_ext=(_p==='meet'||_p==='zoom');var _u=_ext?t.meeting_link:'/pages/eoh-meeting-room?'+new URLSearchParams({platform:_p,link:t.meeting_link,name:(window.USER&&window.USER.full_name)||'Client',company:t.company_name||'',ticket:t.ticket_number||'',erp:t.erp_system||''}).toString();return '<a href="'+_u+'" '+(_ext?'target="_blank"':'')+ ' class="join-btn" style="'+( locked2 ?'opacity:.3;pointer-events:none':'')+'">⚡ EOH Meeting →</a>';})()
      + (locked2 ? '<div style="font-size:11px;color:var(--muted);margin-top:8px">🔒 Unlocks 15 minutes before the meeting</div>' : '')
      + '</div>';
  } else if (['paid', 'assigned'].includes(t.status)) {
    meetHtml = '<div class="await-box"><span style="font-size:20px">⏳</span><div><b>Awaiting consultant assignment</b><br><span style="font-size:12px;color:var(--muted)">Our team is matching you with the right consultant.</span></div></div>';
  }

  return '<div class="tk-card" id="tkc-' + t.id + '">'
    + '<div class="tk-card-hdr" onclick="toggleTkCard(\'' + t.id + '\')">'
    + '<div><div style="display:flex;align-items:center;gap:8px">'
    + '<span style="font-size:13px;font-weight:700;color:var(--gl);font-family:monospace">' + esc(t.ticket_number || '—') + '</span>'
    + badge(t.status) + badge(t.priority)
    + '</div><div style="font-size:14px;font-weight:600;margin-top:2px">' + esc(t.erp_system || '—') + ' — ' + esc((t.support_type || '').replace(/_/g, ' ')) + '</div>'
    + (t.project ? '<div style="font-size:12px;color:var(--muted);margin-top:2px">📁 ' + esc((t.project.project_number || '') + ' ' + (t.project.title || '')) + '</div>' : '')
    + '</div>'
    + '<div style="display:flex;align-items:center;gap:10px;flex-shrink:0">'
    + (isPaid ? '<span style="font-size:10px;background:rgba(15,181,116,.1);color:var(--gl);border-radius:10px;padding:2px 8px;font-weight:700">✅ PAID</span>' : '<span style="font-size:10px;background:rgba(245,158,11,.1);color:var(--warn);border-radius:10px;padding:2px 8px;font-weight:700">⏳ UNPAID</span>')
    + '<span style="font-size:12px;color:var(--muted)">' + fmtDate(t.created_at) + '</span>'
    + '<span id="tkchev-' + t.id + '" style="font-size:14px;color:var(--muted)">▼</span>'
    + '</div></div>'
    + '<div class="tk-card-body" id="tkb-' + t.id + '">'
    + meetHtml
    + '<div class="tk-detail-grid">'
    + '<div class="tk-detail-sec"><h4>Request Details</h4>'
    + '<div class="tk-drow"><span class="k">ERP System</span><span>' + esc(t.erp_system || '') + (t.erp_version ? ' (' + t.erp_version + ')' : '') + '</span></div>'
    + '<div class="tk-drow"><span class="k">Support Type</span><span>' + esc((t.support_type || '').replace(/_/g, ' ')) + '</span></div>'
    + '<div class="tk-drow"><span class="k">Modules</span><span>' + esc((t.modules || []).join(', ') || '—') + '</span></div>'
    + '<div class="tk-drow"><span class="k">Priority</span><span>' + badge(t.priority) + '</span></div>'
    + '<div class="tk-drow"><span class="k">Submitted</span><span>' + fmtDate(t.created_at) + '</span></div>'
    + '</div>'
    + '<div class="tk-detail-sec"><h4>Meeting &amp; Payment</h4>'
    + '<div class="tk-drow"><span class="k">Timezone</span><span>' + esc(_clUserTz().replace(/_/g, ' ')) + '</span></div>'
    + '<div class="tk-drow"><span class="k">Preferred date</span><span>' + esc(t.preferred_date || '—') + '</span></div>'
    + '<div class="tk-drow"><span class="k">Preferred time</span><span>' + esc(t.preferred_time ? _clFmtTime(t.preferred_time, t.preferred_timezone || null) : '—') + '</span></div>'
    + '<div class="tk-drow"><span class="k">Payment</span><span>' + badge(t.payment_status, isPaid ? 'b-active' : 'b-pending') + '</span></div>'
    + (t.discovery_fee ? '<div class="tk-drow"><span class="k">Fee</span><span>' + esc((t.currency || 'USD') + ' ' + t.discovery_fee) + '</span></div>' : '')
    + '</div></div>'
    + (t.description ? '<div style="margin-top:12px;background:var(--bg3);border-radius:8px;padding:12px;font-size:12px;color:var(--muted);line-height:1.6"><b style="color:var(--text)">Description:</b> ' + esc(t.description) + '</div>' : '')
    + tkTimeline(t.status)
    + (!isPaid && parseFloat(t.discovery_fee || 0) > 0 ? '<div style="margin-top:12px"><button class="btn btn-primary btn-sm" onclick="payTicket(\'' + t.id + '\',\'' + parseFloat(t.discovery_fee).toFixed(2) + '\')">💳 Pay Discovery Fee ($' + parseFloat(t.discovery_fee).toFixed(2) + ')</button></div>' : '')
    + '</div></div>';
}

function tkTimeline(status) {
  var steps = [
    { key: 'pending',   lbl: 'Request submitted',    sub: 'Payment pending' },
    { key: 'paid',      lbl: 'Payment confirmed',     sub: 'Awaiting consultant assignment' },
    { key: 'confirmed', lbl: 'Consultant assigned',   sub: 'Meeting confirmed' },
    { key: 'completed', lbl: 'Meeting completed',     sub: 'Support session done' },
  ];
  var order = ['pending', 'paid', 'assigned', 'confirmed', 'rescheduled', 'completed', 'cancelled'];
  var ci = order.indexOf(status);
  return '<div class="tk-timeline">' + steps.map(function(s, i) {
    var done = ci > i || status === s.key;
    var act  = status === s.key || (s.key === 'confirmed' && ['assigned', 'rescheduled'].includes(status));
    return '<div class="tk-tl ' + (done ? 'done' : act ? 'act' : '') + '"><div class="tk-tl-lbl">' + s.lbl + '</div><div>' + s.sub + '</div></div>';
  }).join('') + '</div>';
}

function toggleTkCard(id) {
  var body = document.getElementById('tkb-' + id);
  var chev = document.getElementById('tkchev-' + id);
  var open = body && body.classList.contains('open');
  if (body) body.classList.toggle('open', !open);
  if (chev) chev.style.transform = open ? '' : 'rotate(180deg)';
}

async function payTicket(ticketId) {
  var r = await api('POST', '/proj/tickets/create-payment', { ticket_id: ticketId });
  var d = await r.json();
  if (r.ok && d.checkout_url) location.href = d.checkout_url;
  else toast('❌ ' + (d.error || 'Payment failed'), 'err');
}

// ── Countdown timer ───────────────────────────────────────────────────────────
function tkCountdown(date, time) {
  try {
    var t  = String(time || '').replace(/Z$/i, '').replace(/:\d{2}$/, '').trim();
    var dt = new Date(date + 'T' + t + ':00Z');
    if (isNaN(dt)) return { display: '📅 Date TBC', canJoin: false };
    var now = Date.now(), diff = dt.getTime() - now, end = dt.getTime() + 3600000;
    if (now > end) return { display: '✅ Meeting ended', canJoin: false };
    if (diff <= 0) return { display: '🟢 Live now!', canJoin: true };
    var canJoin = diff <= 900000;
    var s = Math.ceil(diff / 1000), days = Math.floor(s / 86400), hrs = Math.floor((s % 86400) / 3600), mins = Math.floor((s % 3600) / 60), secs = s % 60;
    var parts = []; if (days) parts.push(days + 'd'); if (hrs) parts.push(hrs + 'h'); if (mins) parts.push(mins + 'm'); if (!days) parts.push(('0' + secs).slice(-2) + 's');
    return { display: '⏱ ' + parts.join(' '), canJoin: canJoin };
  } catch(e) { return { display: '📅 Date TBC', canJoin: false }; }
}

setInterval(function() {
  Object.keys(_tkCountdowns).forEach(function(tid) {
    var reg = _tkCountdowns[tid];
    var el  = document.getElementById('tkcd-' + tid);
    if (!el) { delete _tkCountdowns[tid]; return; }
    var cd  = tkCountdown(reg.date, reg.time);
    el.textContent = cd.display;
    if (cd.canJoin) { el.style.color = 'var(--gl)'; }
    if (cd.display === '✅ Meeting ended') { el.style.color = 'var(--muted)'; delete _tkCountdowns[tid]; }
  });
}, 1000);

// ── Global Meetings ───────────────────────────────────────────────────────────
async function loadGlobalMeetings() {
  var el = document.getElementById('global-meetings-list');
  if (!el) return;
  el.innerHTML = '<div class="empty"><div class="empty-icon">⏳</div>Loading...</div>';

  // Fetch discovery meetings (confirmed assignments for client's tickets)
  var discMeetings = [];
  try {
    var dr = await api('GET', '/proj/client-meetings');
    if (dr.ok) { var dd = await dr.json(); discMeetings = (dd.meetings || []).map(function(m){ return Object.assign({}, m, { _source: 'discovery', _type: 'Discovery Meeting' }); }); }
  } catch(e) {}

  // Fetch project meetings
  var projMeetings = [];
  for (var p of _projects) {
    try {
      var r = await api('GET', '/proj/projects/' + p.id);
      var d = await r.json();
      (d.meetings || []).forEach(function(m) {
        projMeetings.push(Object.assign({}, m, { _proj_title: p.title, _proj_id: p.id, _source: 'project', _type: 'Project Meeting' }));
      });
    } catch(e) {}
  }

  if (!discMeetings.length && !projMeetings.length) {
    el.innerHTML = '<div class="card"><div class="empty"><div class="empty-icon">📅</div><p>No meetings yet</p></div></div>';
    return;
  }

  window._clDiscMeetings = discMeetings;
  window._clProjMeetings = projMeetings;

  window._clSortAndRender = function(dir) {
    var s = document.getElementById('mf-sort');
    if (s && dir) s.value = dir;
    applyMeetingFilters();
  };

  el.innerHTML = '<div id="cl-meetings-inner"></div>';
  window._clSortAndRender('upcoming');
}

function applyMeetingFilters() {
  var statusF = (document.getElementById('mf-status') || {}).value || '';
  var typeF   = (document.getElementById('mf-type')   || {}).value || '';
  var sortF   = (document.getElementById('mf-sort')   || {}).value || 'upcoming';
  var now     = Date.now();

  function getMs(m) {
    var d = m.scheduled_date||m.meeting_date||m.date||'';
    var t = m.scheduled_time||m.meeting_time||m.time||'00:00';
    if (!d) return -1;
    var ms = new Date(d+'T'+t.substring(0,5)+':00').getTime();
    return isNaN(ms) ? -1 : ms;
  }

  function filterArr(arr, src) {
    return arr.filter(function(m) {
      var ms = getMs(m);
      var isPast = ms > 0 && now > ms + 3600000;
      var isUp   = ms > now;
      if (statusF === 'upcoming'  && !isUp)   return false;
      if (statusF === 'completed' && !isPast)  return false;
      if (statusF === 'confirmed' && !(m.status==='confirmed'||m.status==='rescheduled')) return false;
      if (typeF && src !== typeF) return false;
      return true;
    });
  }

  function sortArr(arr, dk, tk) {
    return arr.slice().sort(function(a, b) {
      var ma = getMs(a), mb = getMs(b);
      if (ma < 0 && mb < 0) return 0;
      if (ma < 0) return 1;
      if (mb < 0) return -1;
      if (sortF === 'upcoming') {
        var aUp = ma > now, bUp = mb > now;
        if (aUp !== bUp) return aUp ? -1 : 1;
        return aUp ? ma - mb : mb - ma;
      }
      return sortF === 'asc' ? ma - mb : mb - ma;
    });
  }

  var sd = sortArr(filterArr(window._clDiscMeetings||[], 'discovery'), 'date', 'time');
  var sp = sortArr(filterArr(window._clProjMeetings||[], 'project'), 'scheduled_date', 'scheduled_time');

  var inner = document.getElementById('cl-meetings-inner');
  if (!inner) return;
  inner.innerHTML = '';

  if (!sd.length && !sp.length) {
    inner.innerHTML = '<div class="empty" style="padding:40px;text-align:center"><div style="font-size:36px;margin-bottom:10px">🔍</div><div style="color:var(--muted)">No meetings match your filters</div></div>';
    return;
  }

  if (sd.length) {
    inner.insertAdjacentHTML('beforeend',
      '<div style="font-size:12px;font-weight:700;text-transform:uppercase;color:var(--muted);letter-spacing:.06em;margin:0 0 10px">🔍 Discovery Meetings</div>'
      + sd.map(meetingItemHtml).join('')
      + '<div style="margin-bottom:20px"></div>');
  }
  if (sp.length) {
    inner.insertAdjacentHTML('beforeend',
      '<div style="font-size:12px;font-weight:700;text-transform:uppercase;color:var(--muted);letter-spacing:.06em;margin:0 0 10px">📁 Project Meetings</div>');
    var byProj = {};
    sp.forEach(function(m) { if (!byProj[m._proj_id]) byProj[m._proj_id] = []; byProj[m._proj_id].push(m); });
    inner.insertAdjacentHTML('beforeend', Object.keys(byProj).map(function(pid) {
      var ms = byProj[pid];
      return '<div style="margin-bottom:16px"><div style="font-size:11px;font-weight:700;color:var(--gl);margin-bottom:6px">📁 ' + esc(ms[0]._proj_title) + '</div>'
        + ms.map(meetingItemHtml).join('') + '</div>';
    }).join(''));
  }
}

function clearMeetingFilters() {
  ['mf-status','mf-type'].forEach(function(id) { var el=document.getElementById(id); if(el) el.value=''; });
  var s = document.getElementById('mf-sort'); if (s) s.value = 'upcoming';
  applyMeetingFilters();
}

// ── Payment return handlers ───────────────────────────────────────────────────
// ── Reports ─────────────────────────────────────────────────────────────────
async function loadReports() {
  var el = document.getElementById('reports-content');
  if (!el) return;
  el.innerHTML = '<div style="text-align:center;color:var(--muted);padding:32px">Loading reports...</div>';
  var projects = [];
  try { var _prr = await api('GET','/proj/projects'); projects = ((await _prr.json()).projects)||[]; } catch(_er){}
  if (!projects.length) {
    el.innerHTML = '<div class="card"><div class="empty"><div class="empty-icon">📊</div><p>No projects yet</p></div></div>';
    return;
  }
  var html = '<div class="card" style="margin-bottom:20px">'
    +'<div style="font-weight:700;font-size:15px;margin-bottom:14px">📁 Project Summary</div>'
    +'<div style="overflow-x:auto"><table style="width:100%;border-collapse:collapse;font-size:13px">'
    +'<thead><tr style="border-bottom:2px solid var(--border)">'
    +'<th style="padding:8px 12px;text-align:left;color:var(--muted);font-size:11px;font-weight:700;text-transform:uppercase">Project</th>'
    +'<th style="padding:8px 12px;text-align:left;color:var(--muted);font-size:11px;font-weight:700;text-transform:uppercase">ERP</th>'
    +'<th style="padding:8px 12px;text-align:left;color:var(--muted);font-size:11px;font-weight:700;text-transform:uppercase">Status</th>'
    +'<th style="padding:8px 12px;text-align:left;color:var(--muted);font-size:11px;font-weight:700;text-transform:uppercase">Start</th>'
    +'<th style="padding:8px 12px;text-align:left;color:var(--muted);font-size:11px;font-weight:700;text-transform:uppercase">End</th>'
    +'</tr></thead><tbody>';
  projects.forEach(function(p){
    html += '<tr style="border-bottom:1px solid var(--border)">'
      +'<td style="padding:10px 12px;font-weight:600">'+esc(p.title||p.project_number||'—')+'</td>'
      +'<td style="padding:10px 12px;color:var(--muted)">'+esc(p.erp_system||'—')+'</td>'
      +'<td style="padding:10px 12px"><span style="font-size:11px;font-weight:700;padding:2px 8px;border-radius:8px;background:rgba(15,181,116,.1);color:var(--gl)">'+esc((p.status||'—').replace(/_/g,' '))+'</span></td>'
      +'<td style="padding:10px 12px;color:var(--muted);font-size:12px">'+fmtDate(p.start_date)+'</td>'
      +'<td style="padding:10px 12px;color:var(--muted);font-size:12px">'+fmtDate(p.end_date)+'</td></tr>';
  });
  html += '</tbody></table></div></div>';
  html += '<div style="display:grid;grid-template-columns:repeat(auto-fit,minmax(280px,1fr));gap:14px">';
  var _tdArr = [];
  for (var _ii=0; _ii<projects.length; _ii++) {
    try {
      var _trr = await api('GET','/proj/projects/'+projects[_ii].id);
      if (!_trr.ok) continue;
      var _tdd2 = await _trr.json();
      _tdArr.push({project:projects[_ii], tasks:_tdd2.tasks||[], files:_tdd2.files||[]});
    } catch(_ee){}
  }
  _tdArr.forEach(function(pdd){
    var tasks=pdd.tasks, total=tasks.length;
    var done=tasks.filter(function(t){return t.status==='completed'||t.client_status==='confirmed';}).length;
    var inP=tasks.filter(function(t){return t.status==='in_progress';}).length;
    var pend=tasks.filter(function(t){return t.status==='pending';}).length;
    var pct=total?Math.round(done/total*100):0;
    html += '<div class="card">'
      +'<div style="font-weight:700;font-size:13px;margin-bottom:10px">'+esc(pdd.project.title||pdd.project.project_number)+'</div>'
      +'<div style="background:var(--bg4);border-radius:8px;height:8px;overflow:hidden;margin-bottom:8px">'
      +'<div style="background:linear-gradient(90deg,var(--gl),#0a5fcc);height:100%;width:'+pct+'%;border-radius:8px"></div></div>'
      +'<div style="font-size:12px;color:var(--muted);display:flex;justify-content:space-between;margin-bottom:10px">'
      +'<span>'+pct+'% complete</span><span>'+done+'/'+total+' tasks</span></div>'
      +'<div style="display:grid;grid-template-columns:1fr 1fr 1fr;gap:8px">'
      +'<div style="text-align:center;background:var(--bg4);border-radius:8px;padding:8px"><div style="font-weight:800;font-size:18px;color:var(--gl)">'+done+'</div><div style="font-size:10px;color:var(--muted)">Done</div></div>'
      +'<div style="text-align:center;background:var(--bg4);border-radius:8px;padding:8px"><div style="font-weight:800;font-size:18px;color:var(--warn)">'+inP+'</div><div style="font-size:10px;color:var(--muted)">In Progress</div></div>'
      +'<div style="text-align:center;background:var(--bg4);border-radius:8px;padding:8px"><div style="font-weight:800;font-size:18px;color:var(--muted)">'+pend+'</div><div style="font-size:10px;color:var(--muted)">Pending</div></div>'
      +'</div>'+(pdd.files.length?'<div style="margin-top:8px;font-size:11px;color:var(--muted)">📎 '+pdd.files.length+' file'+(pdd.files.length===1?'':'s')+'</div>':'')+'</div>';
  });
  html += '</div>';
  el.innerHTML = html;
  window._repData = _tdArr;
}
function exportReportCSV() {
  if (!window._repData||!window._repData.length) { window.toast&&window.toast('Load reports first','error'); return; }
  var rows=[['Project','Task','Status','Priority','Due Date']];
  window._repData.forEach(function(pd){ pd.tasks.forEach(function(t){ rows.push([pd.project.title||'',t.title||'',t.status||'',t.priority||'',t.due_date||'']); }); });
  var csv=rows.map(function(r){return r.map(function(c){return '"'+String(c).replace(/"/g,'""')+'"';}).join(',');}).join('\n');
  var a=document.createElement('a'); a.href='data:text/csv;charset=utf-8,'+encodeURIComponent(csv);
  a.download='report-'+new Date().toISOString().split('T')[0]+'.csv'; a.click();
}


function checkPaymentReturn() {
  var sp = new URLSearchParams(location.search);
  var payment = sp.get('payment'), ticketId = sp.get('ticket'), sessionId = sp.get('session_id');
  if (!payment || !ticketId) return;
  history.replaceState({}, '', location.pathname);
  goSection('tickets');
  if (payment === 'success') {
    var wiz = document.getElementById('ticket-wizard');
    var lst = document.getElementById('tickets-list');
    if (wiz) wiz.style.display = 'block';
    if (lst) lst.style.display = 'none';
    [1, 2, 3].forEach(function(i) { var s = document.getElementById('ws-' + i); if (s) s.className = 'wiz-step done'; var l = document.getElementById('wl-' + i); if (l) l.className = 'wiz-line done'; });
    var s4 = document.getElementById('ws-4'); if (s4) s4.className = 'wiz-step active';
    [1, 2, 3].forEach(function(i) { var el = document.getElementById('wiz-s' + i); if (el) el.style.display = 'none'; });
    var s4el = document.getElementById('wiz-s4'); if (s4el) s4el.style.display = 'block';
    setTimeout(async function() {
      var r = await api('POST', '/proj/tickets/verify-payment', { ticket_id: ticketId, session_id: sessionId });
      var d = await r.json();
      var dm = document.getElementById('wiz-done-msg');
      if (dm) dm.innerHTML = d.payment_status === 'paid' ? 'Payment confirmed! 🎉 Ticket <b>' + esc(d.ticket && d.ticket.ticket_number || ticketId) + '</b> is now <b style="color:var(--gl)">Paid ✅</b><br>Our team will assign your consultant shortly.' : 'Ticket submitted. Check your email for confirmation.';
    }, 1500);
    // Reload project to re-apply tab locks after payment
    setTimeout(async function() {
      if (_currentProject && _currentProject.project && _currentProject.project.id) {
        var pid = _currentProject.project.id;
        var r2 = await api('GET', '/proj/projects/' + pid);
        if (r2.ok) {
          _currentProject = await r2.json();
          _applyTabLocks(_currentProject);
        }
      }
    }, 2000);
  } else {
    toast('❌ Payment not completed. Please try again.', 'err');
    loadTickets();
  }
}

function checkInvoiceReturn() {
  var sp = new URLSearchParams(location.search);
  var result = sp.get('inv_payment'), invId = sp.get('invoice'), sid = sp.get('session_id');
  if (!result || !invId) return;
  history.replaceState({}, '', location.pathname);
  if (result === 'success') {
    toast('&#9203; Verifying payment…', 'ok');
    setTimeout(async function() {
      try {
        var r = await api('POST', '/proj/invoices/' + invId + '/verify-payment', { session_id: sid });
        var d = await r.json();
        if (d.paid) {
          toast('&#127881; Invoice payment confirmed! Check your email for receipt.', 'ok');
        } else {
          toast('Payment pending — check your email for confirmation.', 'ok');
        }
      } catch(e) {
        toast('Could not verify payment status. Check your email.', 'err');
      }
      // Refresh projects so updated payment status shows
      loadProjects();
    }, 2500);
  }
  // Failed/cancelled payments now redirect to /pages/client-invoice directly — nothing to do here
}

// ── Profile ───────────────────────────────────────────────────────────────────
function fillProfile(u) {
  if (!u) return;
  var map = { 'p-name': u.full_name, 'p-phone': u.phone, 'p-country': u.country };
  Object.keys(map).forEach(function(id) { var el = document.getElementById(id); if (el) el.value = map[id] || ''; });
  var pEmail = document.getElementById('p-email'); if (pEmail) pEmail.textContent = u.email || '—';
  try { var pTz = document.getElementById('p-tz'); if (pTz && u.timezone) pTz.value = u.timezone; } catch(e) {}
  if (u.profile) {
    var co = document.getElementById('p-company'); if (co) co.value = u.profile.company_name || '';
    try { var ind = document.getElementById('p-industry'); if (ind && u.profile.industry) ind.value = u.profile.industry; } catch(e) {}
  }
}

async function refreshProfile() {
  try {
    var r = await api('GET', '/proj/auth/me');
    if (!r.ok) { fillProfile(USER); initClientProfileCard(); return; }
    var d = await r.json();
    USER = d.user || USER;
    localStorage.setItem('ls_proj_user', JSON.stringify(USER));
    fillProfile(USER);
    initClientProfileCard(); // refresh avatar with latest user data
  } catch(e) { fillProfile(USER); initClientProfileCard(); }
}

async function saveProfile() {
  var msg = document.getElementById('profile-msg');
  msg.innerHTML = '';
  try {
    var r = await api('PUT', '/proj/auth/me', {
      full_name: ((document.getElementById('p-name') || {}).value || '').trim(),
      phone:     ((document.getElementById('p-phone') || {}).value || '').trim(),
      country:   ((document.getElementById('p-country') || {}).value || '').trim(),
      timezone:  (document.getElementById('p-tz') || {}).value || 'UTC',
      profile: {
        company_name: ((document.getElementById('p-company') || {}).value || '').trim(),
        industry:     (document.getElementById('p-industry') || {}).value || '',
      },
    });
    var d = await r.json();
    if (r.ok) {
      USER = d.user || USER;
      // Patch timezone directly in case API returns different structure
      var newTz = (document.getElementById('p-tz') || {}).value;
      if (newTz && USER) { USER.timezone = newTz; }
      localStorage.setItem('ls_proj_user', JSON.stringify(USER));
      fillProfile(USER);
      // Re-render meetings with new timezone
      if (typeof loadGlobalMeetings === 'function') loadGlobalMeetings();
      if (_currentProject) openProject(_currentProject.id || (_currentProject.project && _currentProject.project.id)).catch(function(){});
      msg.innerHTML = '<div class="ok-msg">✅ Profile updated successfully</div>';
      setTimeout(function() { msg.innerHTML = ''; }, 3000);
    } else {
      msg.innerHTML = '<div class="err-msg">❌ ' + esc(d.error || 'Save failed') + '</div>';
    }
  } catch(e) {
    msg.innerHTML = '<div class="err-msg">❌ Network error — please try again</div>';
  }
}

async function changePassword() {
  var msg  = document.getElementById('pw-msg');
  var oldP = ((document.getElementById('p-old-pw') || {}).value || '');
  var newP = ((document.getElementById('p-new-pw') || {}).value || '');
  var newP2 = ((document.getElementById('p-new-pw2') || {}).value || '');
  msg.innerHTML = '';
  if (!oldP)            { msg.innerHTML = '<div class="err-msg">Current password required</div>'; return; }
  if (!newP || newP.length < 8) { msg.innerHTML = '<div class="err-msg">New password must be at least 8 characters</div>'; return; }
  if (newP !== newP2)   { msg.innerHTML = '<div class="err-msg">Passwords do not match</div>'; return; }
  try {
    var r = await api('PUT', '/proj/auth/me', { old_password: oldP, password: newP });
    var d = await r.json();
    if (r.ok) {
      msg.innerHTML = '<div class="ok-msg">✅ Password changed successfully</div>';
      ['p-old-pw', 'p-new-pw', 'p-new-pw2'].forEach(function(id) { var el = document.getElementById(id); if (el) el.value = ''; });
      setTimeout(function() { msg.innerHTML = ''; }, 4000);
    } else {
      msg.innerHTML = '<div class="err-msg">❌ ' + esc(d.error || 'Failed') + '</div>';
    }
  } catch(e) {
    msg.innerHTML = '<div class="err-msg">❌ Network error — please try again</div>';
  }
}

// ── Notifications ─────────────────────────────────────────────────────────────
var NOTIF_ICONS = {
  task_assigned: '📋', task_client_confirmed: '✅', task_client_rejected: '❌',
  meeting_scheduled: '📅', document_submitted: '📄', document_approved: '✅', document_rejected: '📝',
  estimate_sent: '💰', invoice_sent: '🧾', invoice_paid: '💳',
  admin_message: '📢', new_message: '&#128172;', project_assigned: '📁', default: '🔔',
};

function startNotifPoll() {
  loadNotifs();
  _notifPoll = setInterval(function() { pollNotifCount(); }, 15000);
}

async function loadNotifs() {
  try {
    var r = await api('GET', '/proj/notifications');
    var d = await r.json();
    _notifData = d.notifications || [];
    updateNotifBadge(d.unread || d.count || _notifData.filter(function(n){ return !n.is_read; }).length);
    if (_notifOpen) renderNotifs();
  } catch(e) {}
}

async function pollNotifCount() {
  try {
    var r = await api('GET', '/proj/notifications/unread-count');
    var d = await r.json();
    updateNotifBadge(d.unread || d.count || 0);
  } catch(e) {}
}

function updateNotifBadge(count) {
  var dot = document.getElementById('notif-dot');
  if (!dot) return;
  if (count > 0) { dot.textContent = count > 99 ? '99+' : count; dot.style.display = 'inline'; }
  else { dot.style.display = 'none'; }
  document.title = count > 0 ? '(' + count + ') Client Portal' : 'Client Portal — ERP Online Hub';
}

function toggleNotifPanel() {
  _notifOpen = !_notifOpen;
  var panel = document.getElementById('notif-panel');
  if (!panel) return;
  panel.classList.toggle('open', _notifOpen);
  if (_notifOpen) loadNotifs();
}

document.addEventListener('click', function(e) {
  if (_notifOpen && !e.target.closest('#notif-panel') && !e.target.closest('#notif-bell')) {
    _notifOpen = false;
    var p = document.getElementById('notif-panel');
    if (p) p.classList.remove('open');
  }
});

function renderNotifs() {
  var el = document.getElementById('notif-list');
  if (!el) return;
  if (!_notifData.length) { el.innerHTML = '<div class="notif-empty">🎉 All caught up! No notifications.</div>'; return; }
  el.innerHTML = _notifData.map(function(n) {
    var icon = (_NOTIF_ICONS||NOTIF_ICONS||{})[n.type] || '🔔';
    return '<div class="notif-item ' + (n.is_read ? '' : 'unread') + '" onclick="notifClick(\'' + n.id + '\',\'' + esc(n.link || '') + '\')">'
      + '<div class="notif-icon">' + icon + '</div>'
      + '<div class="notif-body"><div class="notif-ntitle">' + esc(n.title) + '</div>'
      + (n.body ? '<div class="notif-ndesc">' + esc(n.body) + '</div>' : '')
      + '<div class="notif-time">' + timeAgo(n.created_at) + '</div></div>'
      + (n.is_read ? '' : '<div style="width:8px;height:8px;border-radius:50%;background:var(--gl);flex-shrink:0;margin-top:6px"></div>')
      + '</div>';
  }).join('');
}

async function notifClick(id, link) {
  await api('PUT', '/proj/notifications/' + id + '/read').catch(function() {});
  var n = _notifData.find(function(x) { return x.id === id; });
  if (n) n.is_read = true;
  updateNotifBadge(_notifData.filter(function(x){ return !x.is_read; }).length);
  renderNotifs();
  if (!link || link === 'undefined') return;
  toggleNotifPanel();
  if (link.startsWith('project:')) {
    var parts = link.split(':');
    var pid = parts[1], tab = parts[2] || 'tasks';
    openProject(pid, tab);
  } else if (link.startsWith('section:')) {
    refreshProjectTab(link.replace('section:', ''));
  } else if (link.startsWith('http')) {
    location.href = link;
  }
}

async function markNotifRead(id, rowEl, link) {
  await api('PUT', '/proj/notifications/' + id + '/read').catch(function() {});
  var n = _notifData.find(function(x) { return x.id === id; });
  if (n) { n.is_read = true; }
  if (rowEl) {
    rowEl.style.background = 'transparent';
    var dot = rowEl.querySelector('[style*="border-radius:50%"]');
    if (dot) dot.remove();
  }
  updateNotifBadge(_notifData.filter(function(n){ return !n.is_read; }).length);
  // Navigate based on link
  if (link) {
    toggleNotifPanel();
    if (link.startsWith('project:')) {
      var parts = link.split(':');
      var pid = parts[1], tab = parts[2] || 'overview';
      // Navigate to the project tasks/chat tab
      var proj = (_projects || []).find(function(p){ return p.id === pid; });
      if (proj) openProject(pid, tab);
    } else if (link.startsWith('section:')) {
      var sec = link.replace('section:', '');
      // For client portal, map section names
      var tabMap = { tasks: 'tasks', chat: 'chat', invoices: 'invoices', meetings: 'meetings' };
      if (tabMap[sec]) refreshProjectTab(tabMap[sec]);
    }
  }
}

async function notifMarkAll() {
  await api('PUT', '/proj/notifications/read-all').catch(function() {});
  _notifData.forEach(function(n) { n.is_read = true; });
  updateNotifBadge(0);
  renderNotifs();
}

// ── ERP Systems — loaded from admin settings ─────────────────────────────────
var _erpSystems = [];

async function loadErpSystems() {
  try {
    var r = await fetch('https://erp-ai-backend.vercel.app/proj/settings/erp-systems');
    var d = await r.json();
    _erpSystems = d.systems || [];
  } catch(e) {
    _erpSystems = [
      {name:'SAP',enabled:true},{name:'Oracle',enabled:true},
      {name:'Microsoft Dynamics',enabled:true},{name:'Workday',enabled:true},
      {name:'Odoo',enabled:true},{name:'NetSuite',enabled:true},
      {name:'Sage',enabled:true},{name:'Other',enabled:true},
    ];
  }
  _populateErpSelect('nt-erp', 'Select ERP…');
  _populateErpSelect('np-erp', 'Select ERP system…');
}

function _populateErpSelect(elId, placeholder) {
  var sel = document.getElementById(elId);
  if (!sel) return;
  var prev = sel.value;
  sel.innerHTML = '<option value="">' + placeholder + '</option>';
  _erpSystems.forEach(function(s) {
    if (!s.enabled && !s.coming_soon) return; // fully hidden
    var opt = document.createElement('option');
    opt.value = s.name;
    opt.disabled = !!s.coming_soon;
    opt.textContent = s.name + (s.coming_soon ? ' — Coming Soon' : '');
    sel.appendChild(opt);
  });
  if (prev) sel.value = prev;
}

// Call on page load
loadErpSystems();

// ── Profile Card: Avatar, Profile ID, QR ─────────────────────────────────────
function _clientProfileId(id) {
  return 'EOH-CL-' + (id||'').replace(/-/g,'').substring(0,8).toUpperCase();
}

function _loadQRLib(cb) {
  if (window.QRCode) { cb(); return; }
  var s = document.createElement('script');
  s.src = 'https://cdnjs.cloudflare.com/ajax/libs/qrcodejs/1.0.0/qrcode.min.js';
  s.onload = cb;
  document.head.appendChild(s);
}

function initClientProfileCard() {
  var wrap = document.getElementById('client-profile-card');
  if (!wrap) return;
  if (!USER) return;

  // If card already rendered, just refresh avatar if available
  if (wrap.children.length) {
    var av2 = (USER.profile && USER.profile.avatar_url) ? USER.profile.avatar_url : '';
    if (av2) {
      var circle2 = document.getElementById('cl-avatar-circle');
      if (circle2) {
        circle2.setAttribute('style','width:88px;height:88px;border-radius:50%;background:url('+esc(av2)+') center/cover no-repeat;border:3px solid var(--border);overflow:hidden;flex-shrink:0');
        circle2.innerHTML = '';
      }
    }
    return;
  }

  var id       = USER.id;
  var name     = USER.full_name || 'Client';
  var pid      = _clientProfileId(id);
  var pUrl     = 'https://erponlinehub.com/pages/eoh-public-profile?id=' + id + '&type=client';
  var av       = (USER.profile && USER.profile.avatar_url) ? USER.profile.avatar_url : '';
  var initials = name.split(' ').map(function(w){ return w[0]; }).join('').substring(0,2).toUpperCase();

  wrap.style.cssText = 'background:var(--bg2);border:1px solid var(--border);border-radius:12px;padding:20px;margin-bottom:20px;max-width:800px;display:flex;align-items:flex-start;gap:20px;flex-wrap:wrap';
  wrap.innerHTML =
    '<div style="display:flex;flex-direction:column;align-items:center;gap:10px;flex-shrink:0">'
    + '<div style="position:relative;cursor:pointer" onclick="document.getElementById(\'cl-avatar-input\').click()" title="Click to change photo">'
    +   '<div id="cl-avatar-circle" style="width:88px;height:88px;border-radius:50%;'
    +     (av
        ? 'background:url('+esc(av)+') center/cover no-repeat;'
        : 'background:linear-gradient(135deg,#0fb574,#0A4FCC);display:flex;align-items:center;justify-content:center;font-size:30px;font-weight:800;color:#fff;')
    +   'border:3px solid var(--border);overflow:hidden;flex-shrink:0">'
    +     (av ? '' : '<span>'+initials+'</span>')
    +   '</div>'
    +   '<div style="position:absolute;bottom:0;right:0;width:24px;height:24px;background:var(--gl);border-radius:50%;display:flex;align-items:center;justify-content:center;font-size:13px;border:2px solid var(--bg2)">📷</div>'
    + '</div>'
    + '<input type="file" id="cl-avatar-input" accept="image/*" style="display:none" onchange="uploadClientAvatar(this)">'
    + '<div id="cl-avatar-msg" style="font-size:11px;color:var(--muted);text-align:center;max-width:96px"></div>'
    + '</div>'
    + '<div style="flex:1;min-width:0">'
    +   '<div style="font-size:18px;font-weight:800;margin-bottom:2px">'+esc(name)+'</div>'
    +   '<div style="font-size:11px;color:var(--muted);text-transform:uppercase;letter-spacing:.06em;margin-bottom:12px">Client</div>'
    +   '<div style="display:flex;align-items:center;gap:8px;margin-bottom:12px;flex-wrap:wrap">'
    +     '<div style="background:var(--bg3);border:1px solid var(--border);border-radius:8px;padding:6px 12px;font-family:monospace;font-size:13px;font-weight:700;color:var(--gl);letter-spacing:.08em">'+pid+'</div>'
    +     '<button onclick="copyClientProfileId(\''+pid+'\')" style="background:none;border:1px solid var(--border);border-radius:6px;padding:4px 8px;font-size:11px;color:var(--muted);cursor:pointer;font-family:inherit">📋 Copy ID</button>'
    +     '<a href="'+esc(pUrl)+'" target="_blank" style="background:rgba(15,181,116,.1);border:1px solid rgba(15,181,116,.25);border-radius:6px;padding:4px 8px;font-size:11px;color:var(--gl);text-decoration:none;font-weight:600">🌐 Public Profile</a>'
    +   '</div>'
    +   '<div style="font-size:11px;color:var(--muted);line-height:1.5">Your unique profile ID and QR code. Share them so people can find and message you.</div>'
    + '</div>'
    + '<div style="display:flex;flex-direction:column;align-items:center;gap:8px;flex-shrink:0">'
    +   '<div style="font-size:10px;font-weight:700;text-transform:uppercase;color:var(--muted);letter-spacing:.06em">QR Code</div>'
    +   '<div id="cl-profile-qr" style="background:#fff;border-radius:8px;padding:6px;width:110px;height:110px;display:flex;align-items:center;justify-content:center"></div>'
    +   '<button onclick="downloadClientQR()" style="background:none;border:1px solid var(--border);border-radius:6px;padding:4px 10px;font-size:10px;color:var(--muted);cursor:pointer;font-family:inherit">⬇ Download</button>'
    + '</div>';

  _loadQRLib(function() {
    var qrEl = document.getElementById('cl-profile-qr');
    if (!qrEl || !window.QRCode) return;
    try {
      new QRCode(qrEl, { text: pUrl, width: 98, height: 98, colorDark: '#0a8a5f', colorLight: '#ffffff', correctLevel: QRCode.CorrectLevel.M });
    } catch(e) {}
  });
}

async function uploadClientAvatar(input) {
  var file = input.files && input.files[0];
  if (!file) return;
  var msg = document.getElementById('cl-avatar-msg');
  if (msg) msg.textContent = 'Uploading…';
  var form = new FormData();
  form.append('avatar', file);
  try {
    var r = await fetch(API + '/proj/profile/avatar', { method:'POST', headers:{'Authorization':'Bearer '+TOKEN}, body:form });
    var d = await r.json();
    if (r.ok && d.avatar_url) {
      var circle = document.getElementById('cl-avatar-circle');
      if (circle) {
        circle.setAttribute('style','width:88px;height:88px;border-radius:50%;background:url('+esc(d.avatar_url)+') center/cover no-repeat;border:3px solid var(--border);overflow:hidden;flex-shrink:0');
        circle.innerHTML = '';
      }
      var navAv2 = document.getElementById('nav-av');
      if (navAv2) {
        navAv2.textContent = '';
        navAv2.style.backgroundImage    = 'url(' + d.avatar_url + ')';
        navAv2.style.backgroundSize     = 'cover';
        navAv2.style.backgroundPosition = 'center';
      }
      if (USER) { if (!USER.profile) USER.profile={}; USER.profile.avatar_url = d.avatar_url; localStorage.setItem('ls_proj_user', JSON.stringify(USER)); }
      if (msg) msg.textContent = '✓ Updated';
      setTimeout(function(){ if(msg) msg.textContent=''; }, 2000);
    } else { if(msg) { msg.textContent = d.error||'Failed'; setTimeout(function(){ msg.textContent=''; },3000); } }
  } catch(e) { if(msg) { msg.textContent = e.message; setTimeout(function(){ msg.textContent=''; },3000); } }
  input.value = '';
}

function copyClientProfileId(pid) {
  navigator.clipboard && navigator.clipboard.writeText(pid).then(function(){ toast('Profile ID copied', 'ok'); }).catch(function(){});
}

function downloadClientQR() {
  var qrEl = document.getElementById('cl-profile-qr');
  if (!qrEl) return;
  var img = qrEl.querySelector('img') || qrEl.querySelector('canvas');
  if (!img) return;
  var src = img.src || (img.tagName==='CANVAS' ? img.toDataURL('image/png') : null);
  if (!src) return;
  var a = document.createElement('a'); a.href=src; a.download=_clientProfileId(USER&&USER.id)+'-QR.png'; a.click();
}

// Trigger init when profile section is shown
(function() {
  var origShowSection = window.showSection;
  if (typeof origShowSection === 'function') {
    window.showSection = function(id, el) {
      origShowSection(id, el);
      if (id === 'profile') setTimeout(initClientProfileCard, 100);
    };
  }
  // Also init on fillProfile
  var origFillProfile = window.fillProfile;
  if (typeof origFillProfile === 'function') {
    window.fillProfile = function(u) {
      origFillProfile(u);
      setTimeout(initClientProfileCard, 100);
    };
  }
})();
// ── Client Inbox ──────────────────────────────────────────────────────────────
var _clInboxConvId = null, _clInboxPoll = null;

async function loadClientInbox() {
  var listEl = document.getElementById('cl-inbox-conv-list');
  if (!listEl) return;
  listEl.innerHTML = '<div style="padding:24px;text-align:center;color:var(--muted);font-size:13px">Loading…</div>';
  try {
    var r = await api('GET', '/proj/inbox');
    if (!r.ok) { listEl.innerHTML = '<div style="padding:20px;color:var(--muted)">Could not load inbox</div>'; return; }
    var d = await r.json();
    var convs = d.conversations || [];
    var totalUnread = convs.reduce(function(s,c){ return s+(c.unread||0); },0);
    var badge = document.getElementById('inbox-cl-badge');
    if (badge) { badge.textContent = totalUnread > 99 ? '99+' : totalUnread; badge.style.display = totalUnread ? 'inline' : 'none'; }
    if (!convs.length) { listEl.innerHTML = '<div style="padding:32px 16px;text-align:center;color:var(--muted);font-size:13px">📭 No messages yet.</div>'; return; }
    listEl.innerHTML = '';
    convs.forEach(function(c) {
      var row = document.createElement('div');
      row.dataset.convId = c.id;
      row.style.cssText = 'display:flex;align-items:flex-start;gap:10px;padding:12px 14px;border-bottom:1px solid var(--border);cursor:pointer;transition:.15s;background:' + (c.id===_clInboxConvId?'rgba(15,181,116,.07)':'transparent') + ';border-left:3px solid ' + (c.id===_clInboxConvId?'var(--gl)':'transparent');
      var av = (c.other_name||'?')[0].toUpperCase();
      var tc = c.other_type==='consultant'?'var(--gl)':c.other_type==='manager'?'#a78bfa':'#60a5fa';
      row.innerHTML = '<div style="width:36px;height:36px;border-radius:50%;background:'+tc+'22;color:'+tc+';display:flex;align-items:center;justify-content:center;font-weight:800;font-size:15px;flex-shrink:0">'+esc(av)+'</div>'
        +'<div style="flex:1;min-width:0"><div style="display:flex;justify-content:space-between;align-items:center"><div style="font-size:13px;font-weight:'+(c.unread>0?'800':'600')+';overflow:hidden;text-overflow:ellipsis;white-space:nowrap">'+esc(c.other_name)+'</div>'+(c.unread>0?'<span style="background:var(--danger);color:#fff;border-radius:10px;padding:1px 6px;font-size:9px;font-weight:800;flex-shrink:0;margin-left:4px">'+c.unread+'</span>':'')+'</div>'
        +'<div style="font-size:11px;color:var(--muted);overflow:hidden;text-overflow:ellipsis;white-space:nowrap;margin-top:2px">'+esc(c.last_message||'')+'</div>'
        +'<div style="font-size:10px;color:var(--dim);margin-top:2px">'+(c.last_message_at?timeAgo(c.last_message_at):'')+'</div></div>';
      row.addEventListener('click', function(){ openClInboxConv(c.id, c.other_name, c.other_type); });
      row.addEventListener('mouseover', function(){ if(c.id!==_clInboxConvId) row.style.background='var(--bg3)'; });
      row.addEventListener('mouseout',  function(){ if(c.id!==_clInboxConvId) row.style.background='transparent'; });
      listEl.appendChild(row);
    });
  } catch(e) { listEl.innerHTML = '<div style="padding:20px;color:var(--muted)">Error</div>'; }
}

async function openClInboxConv(convId, otherName, otherType) {
  _clInboxConvId = convId;
  document.querySelectorAll('#cl-inbox-conv-list > div').forEach(function(r){
    var active = r.dataset.convId===convId;
    r.style.background = active?'rgba(15,181,116,.07)':'transparent';
    r.style.borderLeft  = active?'3px solid var(--gl)':'3px solid transparent';
  });
  var hdr = document.getElementById('cl-inbox-hdr');
  if (hdr) hdr.innerHTML = '<span style="font-weight:800">'+esc(otherName)+'</span> <span style="font-size:11px;color:var(--muted);margin-left:6px">'+(otherType==='consultant'?'Consultant':otherType==='manager'?'ERP Manager':'Client')+'</span>';
  var msgsEl = document.getElementById('cl-inbox-msgs');
  if (msgsEl) msgsEl.innerHTML = '<div style="text-align:center;color:var(--muted);padding:20px;font-size:13px">Loading…</div>';
  try {
    var r = await api('GET', '/proj/inbox/'+convId);
    if (!r.ok) return;
    var d = await r.json();
    _renderClThread(d.messages||[]);
    var compose = document.getElementById('cl-inbox-compose');
    if (compose) compose.style.display = 'flex';
    if (_clInboxPoll) clearInterval(_clInboxPoll);
    _clInboxPoll = setInterval(async function(){ if(_clInboxConvId===convId){ var r2=await api('GET','/proj/inbox/'+convId).catch(function(){return{ok:false};}); if(r2.ok){var d2=await r2.json();_renderClThread(d2.messages||[]);} }},8000);
    loadClientInbox();
  } catch(e) {}
}

function _renderClThread(messages) {
  var el = document.getElementById('cl-inbox-msgs');
  if (!el) return;
  if (!messages.length) { el.innerHTML = '<div style="text-align:center;color:var(--muted);padding:32px;font-size:13px">No messages yet. Start the conversation!</div>'; return; }
  var myId = USER && USER.id;
  el.innerHTML = messages.map(function(m) {
    var mine = m.sender_id===myId;
    return '<div style="display:flex;flex-direction:column;margin-bottom:4px">'
      +(!mine?'<div style="font-size:10px;font-weight:700;color:var(--muted);margin-bottom:3px">'+esc(m.sender_name)+'</div>':'')
      +'<div style="align-self:'+(mine?'flex-end':'flex-start')+';max-width:70%;background:'+(mine?'linear-gradient(135deg,rgba(15,181,116,.2),rgba(10,76,204,.18));border:1px solid rgba(15,181,116,.28);border-radius:14px 14px 3px 14px':'var(--bg2));border:1px solid var(--border);border-radius:14px 14px 14px 3px')+';padding:10px 14px;font-size:13px;line-height:1.55;word-break:break-word;white-space:pre-wrap">'+esc(m.message)+'</div>'
      +'<div style="font-size:10px;color:var(--dim);margin-top:3px;'+(mine?'text-align:right':'')+'">'+(m.created_at?timeAgo(m.created_at):'')+'</div>'
      +'</div>';
  }).join('');
  el.scrollTop = el.scrollHeight;
}

function _clHasContactInfo(text) {
  if (!text) return false;
  if (/@/.test(text)) return true;
  if (/\b[\w\-]+\.(com|net|org|io|co|me|info|biz|edu|gov|uk|ae|sa|eg|de|fr|ca|au)\b/i.test(text)) return true;
  if (/\d{7,}/.test(text.replace(/[\s\-\.\(\)]/g,''))) return true;
  if (/^\s*[\+\d\s\-\.\(\)]+\s*$/.test(text) && text.replace(/\D/g,'').length >= 4) return true;
  return false;
}

async function sendClInboxReply() {
  if (!_clInboxConvId) return;
  var input = document.getElementById('cl-inbox-input');
  var text  = (input&&input.value||'').trim();
  if (!text) return;

  // Client-side block — show warning without API call
  if (_clHasContactInfo(text)) {
    if (input) { input.value = ''; }
    api('POST', '/proj/inbox/violation', { preview: text.substring(0, 80) })
      .then(function(r){ return r.json(); })
      .then(function(v){
        _showClPolicyWarning(
          'Sharing contact information (email, phone number) is strictly prohibited. Any attempt is automatically detected, removed, and reported. Repeated violations will result in your inbox being permanently locked.',
          v.violation_count
        );
        if (v.auto_locked) toast('🔒 Your inbox has been locked due to repeated violations.', 'err');
      })
      .catch(function(){
        _showClPolicyWarning(
          'Sharing contact information (email, phone number) is strictly prohibited. Any attempt is automatically detected, removed, and reported. Repeated violations will result in your inbox being permanently locked.',
          null
        );
      });
    return;
  }
  try {
    var r1 = await api('GET','/proj/inbox/'+_clInboxConvId);
    if (!r1.ok) return;
    var d1 = await r1.json();
    var conv = d1.conversation;
    var myId = USER&&USER.id;
    var to_id   = conv.participant_a_id===myId?conv.participant_b_id:conv.participant_a_id;
    var to_type = conv.participant_a_id===myId?conv.participant_b_type:conv.participant_a_type;
    if (input) { input.value=''; input.disabled=true; }
    var r = await api('POST','/proj/inbox',{to_id,to_type,message:text});
    var d = await r.json();
    if (r.ok) {
      _renderClThread((d1.messages||[]).concat([d.message]));
      if (d.censored) {
        var rem = Math.max(0, 3-(d.violation_count||1));
        toast('⚠️ Contact info removed. '+(rem>0?rem+' warning'+(rem>1?'s':'')+' left before inbox lock.':'Final warning — next violation locks your inbox permanently.'),'warn');
      }
    } else if (d.fully_blocked || d.auto_locked) {
      _showClPolicyWarning(d.error, d.violation_count);
    } else if (r.status===403) {
      toast('🔒 '+(d.error||'Inbox locked'),'err');
    }
    if (input) { input.disabled=false; input.focus(); }
    loadClientInbox();
  } catch(e) { if(input) input.disabled=false; }
}
function clInboxKey(e){ if(e.key==='Enter'&&!e.shiftKey){e.preventDefault();sendClInboxReply();} }

function _showClPolicyWarning(message, violationCount) {
  var el = document.getElementById('cl-inbox-msgs');
  if (!el) { toast(message||'Contact info not allowed','warn'); return; }
  var existing = el.querySelector('.cl-policy-warn'); if(existing) existing.remove();
  var rem = Math.max(0, 3-(violationCount||1));
  var w = document.createElement('div');
  w.className = 'cl-policy-warn';
  w.style.cssText = 'background:rgba(245,158,11,.08);border:1px solid rgba(245,158,11,.3);border-radius:10px;padding:14px 16px;margin:8px 0;font-size:12px;line-height:1.7';
  w.innerHTML = '<div style="font-size:13px;font-weight:800;color:var(--warn);margin-bottom:6px;display:flex;align-items:center;gap:6px"><span>⚠️</span><span>Message Blocked</span>'+(violationCount?'<span style="margin-left:auto;font-size:10px;font-weight:700;background:rgba(245,158,11,.15);padding:2px 8px;border-radius:8px">Violation '+violationCount+' / 3</span>':'')+'</div>'
    +'<div style="color:var(--text)">'+esc(message||'Sharing contact information is not allowed.')+'</div>'
    +(rem>0?'<div style="margin-top:8px;color:var(--muted);font-size:11px">⚡ '+rem+' warning'+(rem>1?'s':'')+' remaining before your inbox is permanently locked.</div>':'<div style="margin-top:8px;color:var(--danger);font-size:11px;font-weight:700">🔒 Final warning. Your inbox will be locked on the next violation.</div>');
  el.appendChild(w);
  el.scrollTop = el.scrollHeight;
}

// Poll inbox badge every 30s
setInterval(async function(){
  try{var r=await api('GET','/proj/inbox/unread-count');var d=await r.json();var b=document.getElementById('inbox-cl-badge');if(b){b.textContent=d.unread>99?'99+':d.unread;b.style.display=d.unread?'inline':'none';}}catch(e){}
},30000);

